(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dayspan"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["dayspan", "vue"], factory);
	else if(typeof exports === 'object')
		exports["dayspan-vuetify"] = factory(require("dayspan"), require("vue"));
	else
		root["dayspan-vuetify"] = factory(root["dayspan"], root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_191__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("dayspan");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);



// required: property

/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    }
  },

  computed: {
    frequency: {
      get: function get() {
        return this.property ? this.schedule[this.property].input : null;
      },
      set: function set(value) {
        this.property && this.schedule.setFrequency(this.property, value);
      }
    },

    type: {
      get: function get() {
        return this.getFrequencyType(this.frequency);
      },
      set: function set(type) {
        var _this = this;

        this.$dayspan.getPermission('changeExistingType', function () {
          _this.setFrequencyType(type);
        });
      }
    },

    isAny: function isAny() {
      return this.type === 'any';
    },
    isOneOf: function isOneOf() {
      return this.type === 'oneof';
    },
    isEvery: function isEvery() {
      return this.type === 'every';
    }
  },

  watch: {
    property: 'onPropertyChange'
  },

  methods: {
    getCustomFrequencyType: function getCustomFrequencyType(value) {},
    setCustomFrequencyType: function setCustomFrequencyType(type) {},
    getFrequencyType: function getFrequencyType(value) {
      var custom = this.getCustomFrequencyType(value);

      if (custom) return custom;
      if (!value) return 'any';
      if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(value)) return 'oneof';
      if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isFrequencyValueEvery(value)) return 'every';

      return 'unknown';
    },
    setFrequencyType: function setFrequencyType(type) {
      switch (type) {
        case 'any':
          this.frequency = null;
          break;

        case 'oneof':
          if (!__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(this.frequency)) {
            this.frequency = [];
          }
          break;

        case 'every':
          if (!__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isFrequencyValueEvery(this.frequency)) {
            this.frequency = { every: 2 };
          }
          break;

        default:
          this.setCustomFrequencyType(type);
          break;
      }
    },
    onPropertyChange: function onPropertyChange(newProperty, oldProperty) {
      var newValue = [];

      if (oldProperty) {
        var oldValue = this.schedule[oldProperty].input;

        if (oldValue) {
          newValue = oldValue;
        }

        this.schedule.setFrequency(oldProperty, null);
      }

      this.schedule.setFrequency(newProperty, newValue);
    },
    getOffsets: function getOffsets(max, array, start, valueOffset) {
      var offsets = [];
      var min = start || 0;
      var offset = valueOffset || 0;

      for (var i = min; i < max; i++) {
        offsets.push({
          text: array[i],
          value: i + offset
        });
      }

      return offsets;
    },
    findType: function findType(types) {
      for (var i = 0; i < types.length; i++) {
        var type = types[i];

        if (this.schedule[type.property].input) {
          return type;
        }
      }

      return types[0];
    }
  }

});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(8)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Gestures__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Gestures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Gestures__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsGestures", function() { return __WEBPACK_IMPORTED_MODULE_0__Gestures___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Day__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsDay", function() { return __WEBPACK_IMPORTED_MODULE_1__Day___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DayRow__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DayRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DayRow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsDayRow", function() { return __WEBPACK_IMPORTED_MODULE_2__DayRow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DaysView__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DaysView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DaysView__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsDaysView", function() { return __WEBPACK_IMPORTED_MODULE_3__DaysView___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DayTimes__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DayTimes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DayTimes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsDayTimes", function() { return __WEBPACK_IMPORTED_MODULE_4__DayTimes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DayPicker__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DayPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DayPicker__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsDayPicker", function() { return __WEBPACK_IMPORTED_MODULE_5__DayPicker___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Agenda__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Agenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Agenda__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsAgenda", function() { return __WEBPACK_IMPORTED_MODULE_6__Agenda___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AgendaDay__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AgendaDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AgendaDay__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsAgendaDay", function() { return __WEBPACK_IMPORTED_MODULE_7__AgendaDay___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AgendaEvent__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AgendaEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AgendaEvent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsAgendaEvent", function() { return __WEBPACK_IMPORTED_MODULE_8__AgendaEvent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Calendar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Calendar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendar", function() { return __WEBPACK_IMPORTED_MODULE_9__Calendar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CalendarApp__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CalendarApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CalendarApp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarApp", function() { return __WEBPACK_IMPORTED_MODULE_10__CalendarApp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalendarEvent__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalendarEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CalendarEvent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEvent", function() { return __WEBPACK_IMPORTED_MODULE_11__CalendarEvent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CalendarEventTime__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CalendarEventTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CalendarEventTime__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventTime", function() { return __WEBPACK_IMPORTED_MODULE_12__CalendarEventTime___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CalendarEventChip__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CalendarEventChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CalendarEventChip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventChip", function() { return __WEBPACK_IMPORTED_MODULE_13__CalendarEventChip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CalendarEventPopover__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CalendarEventPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CalendarEventPopover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventPopover", function() { return __WEBPACK_IMPORTED_MODULE_14__CalendarEventPopover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CalendarEventPlaceholder__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CalendarEventPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CalendarEventPlaceholder__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventPlaceholder", function() { return __WEBPACK_IMPORTED_MODULE_15__CalendarEventPlaceholder___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CalendarEventCreatePopover__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CalendarEventCreatePopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__CalendarEventCreatePopover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventCreatePopover", function() { return __WEBPACK_IMPORTED_MODULE_16__CalendarEventCreatePopover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CalendarEventTimePlaceholder__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CalendarEventTimePlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__CalendarEventTimePlaceholder__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventTimePlaceholder", function() { return __WEBPACK_IMPORTED_MODULE_17__CalendarEventTimePlaceholder___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Event__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Event__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsEvent", function() { return __WEBPACK_IMPORTED_MODULE_18__Event___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EventDialog__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EventDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__EventDialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsEventDialog", function() { return __WEBPACK_IMPORTED_MODULE_19__EventDialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Schedule__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Schedule__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsSchedule", function() { return __WEBPACK_IMPORTED_MODULE_20__Schedule___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ScheduleSpan__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ScheduleSpan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ScheduleSpan__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleSpan", function() { return __WEBPACK_IMPORTED_MODULE_21__ScheduleSpan___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ScheduleType__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ScheduleType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ScheduleType__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleType", function() { return __WEBPACK_IMPORTED_MODULE_22__ScheduleType___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ScheduleTime__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ScheduleTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ScheduleTime__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTime", function() { return __WEBPACK_IMPORTED_MODULE_23__ScheduleTime___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ScheduleTimes__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ScheduleTimes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ScheduleTimes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTimes", function() { return __WEBPACK_IMPORTED_MODULE_24__ScheduleTimes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ScheduleActions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ScheduleActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ScheduleActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleActions", function() { return __WEBPACK_IMPORTED_MODULE_25__ScheduleActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ScheduleForecast__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ScheduleForecast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ScheduleForecast__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleForecast", function() { return __WEBPACK_IMPORTED_MODULE_26__ScheduleForecast___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ScheduleModifier__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ScheduleModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ScheduleModifier__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleModifier", function() { return __WEBPACK_IMPORTED_MODULE_27__ScheduleModifier___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ScheduleTypeCustom__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ScheduleTypeCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ScheduleTypeCustom__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTypeCustom", function() { return __WEBPACK_IMPORTED_MODULE_28__ScheduleTypeCustom___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ScheduleTypeCustomDialog__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ScheduleTypeCustomDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ScheduleTypeCustomDialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTypeCustomDialog", function() { return __WEBPACK_IMPORTED_MODULE_29__ScheduleTypeCustomDialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ScheduleFrequency__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequency", function() { return __WEBPACK_IMPORTED_MODULE_30__ScheduleFrequency__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ScheduleFrequencyDay__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ScheduleFrequencyDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ScheduleFrequencyDay__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyDay", function() { return __WEBPACK_IMPORTED_MODULE_31__ScheduleFrequencyDay___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ScheduleFrequencyWeek__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ScheduleFrequencyWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ScheduleFrequencyWeek__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyWeek", function() { return __WEBPACK_IMPORTED_MODULE_32__ScheduleFrequencyWeek___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ScheduleFrequencyYear__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ScheduleFrequencyYear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__ScheduleFrequencyYear__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyYear", function() { return __WEBPACK_IMPORTED_MODULE_33__ScheduleFrequencyYear___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ScheduleFrequencyMonth__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ScheduleFrequencyMonth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__ScheduleFrequencyMonth__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyMonth", function() { return __WEBPACK_IMPORTED_MODULE_34__ScheduleFrequencyMonth___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ScheduleFrequencyDayOfWeek__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ScheduleFrequencyDayOfWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__ScheduleFrequencyDayOfWeek__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyDayOfWeek", function() { return __WEBPACK_IMPORTED_MODULE_35__ScheduleFrequencyDayOfWeek___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__WeeksView__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__WeeksView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__WeeksView__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsWeeksView", function() { return __WEBPACK_IMPORTED_MODULE_36__WeeksView___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__WeekHeader__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__WeekHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__WeekHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsWeekHeader", function() { return __WEBPACK_IMPORTED_MODULE_37__WeekHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__WeekDayHeader__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__WeekDayHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__WeekDayHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsWeekDayHeader", function() { return __WEBPACK_IMPORTED_MODULE_38__WeekDayHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__IdentifierChip__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__IdentifierChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__IdentifierChip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DsIdentifierChip", function() { return __WEBPACK_IMPORTED_MODULE_39__IdentifierChip___default.a; });


















































/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = dsMerge;
/* harmony export (immutable) */ __webpack_exports__["a"] = dsMergeOptions;
/* unused harmony export dsMergeOptionsGroup */
/* harmony export (immutable) */ __webpack_exports__["b"] = dsMergeValidate;
/* unused harmony export dsValidate */
/* harmony export (immutable) */ __webpack_exports__["c"] = dsDefaults;
/* harmony export (immutable) */ __webpack_exports__["d"] = dsBind;
/* harmony export (immutable) */ __webpack_exports__["e"] = dsMergeLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);



function dsMerge(target, source) {
  if (!__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(target)) {
    return source;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(source)) {
    for (var prop in source) {
      var sourceValue = source[prop];

      if (prop in target) {
        dsMerge(target[prop], sourceValue);
      } else {
        target[prop] = sourceValue;
      }
    }
  }

  return target;
}

function dsMergeOptions(options, defaults) {
  var out = {
    data: {},
    methods: {},
    computed: {}
  };

  dsMergeOptionsGroup(options, defaults.data, out, out.data);
  dsMergeOptionsGroup(options, defaults.computed, out, out.computed);
  dsMergeOptionsGroup(options, defaults.methods, out, out.methods);

  return out;
}

function dsMergeOptionsGroup(options, group, out, outGroup) {
  for (var prop in group) {
    if (options.data && prop in options.data) {
      out.data[prop] = options.data[prop];

      dsMerge(out.data[prop], group[prop]);
    } else if (options.computed && prop in options.computed) {
      out.computed[prop] = options.computed[prop];

      dsMerge(out.computed[prop], group[prop]);
    } else if (options.methods && prop in options.methods) {
      out.methods[prop] = options.methods[prop];

      dsMerge(out.methods[prop], group[prop]);
    } else {
      outGroup[prop] = group[prop];
    }
  }
}

function dsMergeValidate(target, source) {
  return dsMerge(target, source) !== source;
}

function dsValidate(input, property) {
  return dsMergeValidate(input, this.$dsDefaults()[property]);
}

function dsDefaults() {
  return this.$dayspan.defaults[this.$options.name];
}

function dsBind(bind) {
  return function (data, tag, value, asProp, isSync) {
    if (value && value.$scopedSlots) {
      data.scopedSlots = value.$scopedSlots;
      delete value.$scopedSlots;
    }

    return bind.apply(this, arguments);
  };
}

function dsMergeLocale(currentData, localeData) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(localeData) && __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(currentData) && localeData.length === currentData.length) {
    for (var i = 0; i < localeData.length; i++) {
      var value = localeData[i];

      if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(value) || __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(value)) {
        dsMergeLocale(currentData[i], value, path + '[' + i + ']', strict);
      } else {
        currentData[i] = value;
      }
    }

    return;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(localeData) && __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(currentData)) {
    for (var prop in localeData) {
      var _value = localeData[prop];

      if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(_value) || __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArray(_value)) {
        dsMergeLocale(currentData[prop], _value, path + '.' + prop, strict);
      } else {
        currentData[prop] = _value;
      }
    }

    return;
  }

  if (strict) {
    throw 'Incompatible locale data at ' + path;
  }
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(64);
var IE8_DOM_DEFINE = __webpack_require__(70);
var toPrimitive = __webpack_require__(72);
var dP = Object.defineProperty;

exports.f = __webpack_require__(3) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    // register all components globally
    for (var componentName in __WEBPACK_IMPORTED_MODULE_2__components__) {
      Vue.component(componentName, __WEBPACK_IMPORTED_MODULE_2__components__[componentName]);
    }

    // $dayspan is just another reactive component
    var $dayspan = new Vue(options ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__functions__["a" /* dsMergeOptions */])(options, __WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]);

    // allow directives to access $dayspan
    Vue.$dayspan = $dayspan;

    // allow components to access $dayspan
    Vue.prototype.$dayspan = $dayspan;

    // allow components to pull & merge default component props into given
    // component props.
    Vue.prototype.$dsValidate = __WEBPACK_IMPORTED_MODULE_0__functions__["b" /* dsMergeValidate */];
    Vue.prototype.$dsDefaults = __WEBPACK_IMPORTED_MODULE_0__functions__["c" /* dsDefaults */];

    // allow v-bind="{$scopedSlots}"
    Vue.prototype._b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__functions__["d" /* dsBind */])(Vue.prototype._b);

    // Call initialization functions
    $dayspan.init();
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsAgenda',

  props: {
    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: function data(vm) {
    return {
      placeholder: null,
      placeholderForCreate: false
    };
  },

  computed: {
    eventDays: function eventDays() {
      return this.calendar.days.filter(this.hasEvents);
    }
  },

  methods: {
    hasEvents: function hasEvents(day) {
      return day.events.length > 0;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsAgendaDay',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarDay"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes: function classes() {
      return {
        'ds-day-today': this.day.currentDay,
        'ds-day-past': this.day.currentOffset < 0,
        'ds-day-future': this.day.currentOffset > 0,
        'ds-first-day-day': this.day.dayOfMonth === 1,
        'ds-out-calendar': !this.day.inCalendar
      };
    },
    hasPlaceholder: function hasPlaceholder() {
      return this.placeholder && this.placeholder.time.matchesDay(this.day);
    },
    visibleEvents: function visibleEvents() {
      return this.day.events.filter(this.isVisible);
    }
  },

  methods: {
    isVisible: function isVisible(calendarEvent) {
      if (this.$dayspan.features.hideOnMove && this.placeholder && this.placeholder.event === calendarEvent.event) {
        return false;
      }

      return true;
    },
    add: function add() {
      this.$emit('add', this.day);
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsAgendaEvent',

  props: {
    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    first: {
      type: Boolean,
      default: false
    },

    siblings: {
      type: Number,
      default: 1
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    popoverProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'popoverProps');
      },
      default: function _default() {
        return this.$dsDefaults().popoverProps;
      }
    }
  },

  computed: {
    slotData: function slotData() {
      return {
        readOnly: this.readOnly,
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        details: this.details,
        first: this.first,
        siblings: this.siblings,
        firstLine: this.firstLine,
        secondLine: this.secondLine,
        when: this.when,
        viewDay: this.viewDay,
        edit: this.edit,
        editCheck: this.editCheck
      };
    },
    contentClass: function contentClass() {
      return this.$dayspan.fullscreenPopovers ? 'ds-fullscreen' : '';
    },
    hasPopover: function hasPopover() {
      return !!this.$scopedSlots.eventPopover;
    },
    classes: function classes() {
      return {
        'ds-first-event': this.first
      };
    },
    details: function details() {
      return this.calendarEvent.event.data;
    },
    firstLine: function firstLine() {
      return this.calendarEvent.day.format(this.formats.firstLine);
    },
    secondLine: function secondLine() {
      return this.calendarEvent.day.format(this.formats.secondLine);
    },
    when: function when() {
      return this.$dayspan.getEventAgendaWhen(this.calendarEvent, this.labels, this.formats);
    }
  },

  data: function data(vm) {
    return {
      menu: false
    };
  },

  methods: {
    close: function close() {
      this.menu = false;
    },
    edit: function edit() {
      this.$emit('edit', this.calendarEvent);
    },
    editCheck: function editCheck($event) {
      if (!this.hasPopover) {
        this.edit();
      } else {
        this.menu = !this.menu;
      }
    },
    viewDay: function viewDay() {
      this.$emit('view-day', this.calendarEvent.day);
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        details: this.details,
        left: $event.button === 0,
        right: $event.button === 1,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendar',

  props: {
    calendar: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    handleAdd: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().handleAdd;
      }
    },

    handleMove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().handleMove;
      }
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: function data(vm) {
    return {
      placeholder: null,
      placeholderForCreate: false,
      addStart: null
    };
  },

  watch: {
    '$dayspan.today': 'refreshCurrent'
  },

  computed: {
    type: function type() {
      return this.calendar ? this.calendar.type : null;
    },
    size: function size() {
      return this.calendar ? this.calendar.size : null;
    },
    isDay: function isDay() {
      return this.type === __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].DAY;
    },
    isWeek: function isWeek() {
      return this.type === __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].WEEK;
    },
    isMonth: function isMonth() {
      return this.type === __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].MONTH;
    },
    isYear: function isYear() {
      return this.type === __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].YEAR;
    },
    adding: function adding() {
      return !!(this.addStart && this.placeholder);
    },
    canAdd: function canAdd() {
      return this.$dayspan.features.drag && this.handleAdd && !this.readOnly && !this.$dayspan.readOnly;
    },
    canMove: function canMove() {
      return this.$dayspan.features.move && this.handleMove && !this.readOnly && !this.$dayspan.readOnly;
    }
  },

  methods: {
    refreshCurrent: function refreshCurrent() {
      this.calendar.refreshCurrent(this.$dayspan.today);
    },
    mouseDown: function mouseDown(mouseEvent) {
      if (this.canAdd && mouseEvent.left) {
        var time = mouseEvent.time;
        var ev = this.getEvent('adding', {
          mouseEvent: mouseEvent,
          placeholder: this.$dayspan.getPlaceholderEventForAdd(time)
        });

        this.$emit('adding', ev);

        if (!ev.handled && ev.placeholder) {
          this.addStart = time;
          this.placeholderForCreate = false;
          this.placeholder = ev.placeholder;
          this.placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forTime(time, time.asTime());
          this.placeholder.fullDay = false;
        }
      }
    },
    mouseDownDay: function mouseDownDay(mouseEvent) {
      if (this.canAdd && mouseEvent.left) {
        var day = mouseEvent.day;
        var ev = this.getEvent('adding', {
          mouseEvent: mouseEvent,
          placeholder: this.$dayspan.getPlaceholderEventForAdd(day)
        });

        this.$emit('adding', ev);

        if (!ev.handled && ev.placeholder) {
          this.addStart = day;
          this.placeholderForCreate = false;
          this.placeholder = ev.placeholder;
          this.placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forDay(day);
          this.placeholder.fullDay = true;
        }
      }
    },
    mouseUp: function mouseUp(mouseEvent) {
      if (this.addEnd) {
        this.finishAdd(mouseEvent);
      }

      if (this.moving) {
        this.finishMove(mouseEvent);
      }

      this.readyToMove = false;
    },
    finishAdd: function finishAdd(mouseEvent) {
      var ev = this.getEvent('added', {
        mouseEvent: mouseEvent,
        placeholder: this.placeholder,
        span: this.placeholder.time
      });

      this.$emit('added', ev);

      if (!ev.handled) {
        ev.clearPlaceholder();
      }

      this.endAdd();
    },
    finishMove: function finishMove(mouseEvent) {
      var target = this.placeholder.time;
      var source = this.movingEvent.calendarEvent.time;
      var sameTime = target.start.sameMinute(source.start);
      var sameDay = target.start.sameDay(source.start);
      var isDay = mouseEvent.type === 'mouse-up-day';

      if (isDay && !sameDay || !isDay && !sameTime) {
        var ev = this.getEvent('moved', {
          mouseEvent: mouseEvent,
          movingEvent: this.movingEvent,
          calendarEvent: this.movingEvent.calendarEvent,
          target: this.placeholder.time
        });

        this.$emit('moved', ev);

        if (!ev.handled) {
          ev.clearPlaceholder();
        }
      } else {
        this.clearPlaceholder();
      }

      this.endMove();
    },
    mouseMoveDay: function mouseMoveDay(mouseEvent) {
      if (this.adding && mouseEvent.left) {
        this.addEnd = mouseEvent.day;

        var min = this.addStart.min(this.addEnd);
        var max = this.addStart.max(this.addEnd);

        this.placeholder.day = min.start();
        this.placeholder.time.start = min;
        this.placeholder.time.end = max.end();
        this.placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forDay(this.placeholder.start, this.placeholder.time.days(__WEBPACK_IMPORTED_MODULE_0_dayspan__["Op"].UP));

        this.updatePlaceholderRow(this.placeholder);
      }

      this.mouseMoveCheckReady();

      if (this.moving) {
        var day = mouseEvent.day;

        this.placeholder.day = day;
        this.placeholder.time.start = day;
        this.placeholder.time.end = day.next(this.placeholder.schedule.durationInDays).end();

        this.updatePlaceholderRow(this.placeholder);
      }

      this.mouseMoveCheckEnd(mouseEvent);
    },
    mouseMove: function mouseMove(mouseEvent) {
      if (this.adding && mouseEvent.left) {
        this.addEnd = mouseEvent.timeDrag;

        var min = this.addStart.min(this.addEnd);
        var max = this.addStart.max(this.addEnd);

        this.placeholder.day = min.start();
        this.placeholder.time.start = min;
        this.placeholder.time.end = max;
        this.placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forSpan(this.placeholder.time);
      }

      this.mouseMoveCheckReady();

      if (this.moving) {
        var time = mouseEvent.time;
        time = time.relative(-this.movingEvent.offset);
        time = this.$dayspan.roundTime(time, this.$dayspan.rounding.drag);

        this.placeholder.day = time.start();
        this.placeholder.time.start = time;
        this.placeholder.time.end = time.relative(this.movingDuration);
      }

      this.mouseMoveCheckEnd(mouseEvent);
    },
    mouseMoveCheckEnd: function mouseMoveCheckEnd(mouseEvent) {
      if (this.moving && !mouseEvent.left && !this.placeholderForCreate) {
        this.endMove();
        this.clearPlaceholder();
      }

      if (this.adding && !mouseEvent.left && !this.placeholderForCreate) {
        this.endAdd();
        this.clearPlaceholder();
      }
    },
    mouseDownEvent: function mouseDownEvent(mouseEvent) {
      if (this.canMove && mouseEvent.left) {
        this.readyToMove = true;
        this.movingEvent = mouseEvent;
      }
    },
    mouseMoveCheckReady: function mouseMoveCheckReady() {
      if (this.readyToMove) {
        var moveEvent = this.movingEvent;
        var calendarEvent = moveEvent.calendarEvent;

        var ev = this.getEvent('moving', {
          calendarEvent: calendarEvent,
          moveEvent: moveEvent,
          placeholder: this.$dayspan.getPlaceholderEventForMove(calendarEvent)
        });

        this.$emit('moving', ev);

        if (!ev.handled && ev.placeholder) {
          this.moving = true;
          this.movingDuration = calendarEvent.time.millis();
          this.placeholderForCreate = false;
          this.placeholder = ev.placeholder;
        }

        this.readyToMove = false;
      }
    },
    endMove: function endMove() {
      this.moving = false;
      this.movingEvent = null;
    },
    endAdd: function endAdd() {
      this.addStart = null;
      this.addEnd = null;
    },
    updatePlaceholderRow: function updatePlaceholderRow(placeholder) {
      var row = 0;

      this.calendar.iterateDays().iterate(function (day) {
        if (placeholder.time.matchesDay(day)) {
          row = day.iterateEvents().reduce(row, function (calendarEvent, maxRow) {
            return Math.max(calendarEvent.row + 1, maxRow);
          }, function (calendarEvent) {
            return calendarEvent.event !== placeholder.event;
          });
        }
      });

      placeholder.row = row;
    },
    addPlaceholder: function addPlaceholder(day, fullDay, forUpdate) {
      var placeholder = this.$dayspan.getPlaceholderEventForAdd(day);
      var time = placeholder.time;

      if (fullDay) {
        time.end = time.end.end();

        placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forDay(time.start);
        placeholder.fullDay = true;
      } else {
        time.end = time.end.nextHour();

        placeholder.event.schedule = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forSpan(time);
        placeholder.fullDay = false;
      }

      this.updatePlaceholderRow(placeholder);

      this.placeholder = placeholder;
      this.placeholderForCreate = !forUpdate;
    },
    clearPlaceholder: function clearPlaceholder() {
      this.placeholder = null;
      this.placeholderForCreate = false;
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        calendar: this.calendar,
        clearPlaceholder: this.clearPlaceholder,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarApp',

  props: {
    events: {
      type: Array
    },
    calendar: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"].months();
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().types;
      }
    },
    allowsAddToday: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowsAddToday;
      }
    },
    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    },
    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },
    styles: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'styles');
      },
      default: function _default() {
        return this.$dsDefaults().styles;
      }
    },
    optionsDialog: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'optionsDialog');
      },
      default: function _default() {
        return this.$dsDefaults().optionsDialog;
      }
    },
    promptDialog: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'promptDialog');
      },
      default: function _default() {
        return this.$dsDefaults().promptDialog;
      }
    }
  },

  data: function data(vm) {
    return {
      drawer: null,
      optionsVisible: false,
      options: [],
      promptVisible: false,
      promptQuestion: '',
      promptCallback: null
    };
  },

  watch: {
    'events': 'applyEvents',
    'calendar': 'applyEvents'
  },

  computed: {
    currentType: {
      get: function get() {
        var _this = this;

        return this.types.find(function (type) {
          return type.type === _this.calendar.type && type.size === _this.calendar.size;
        }) || this.types[0];
      },
      set: function set(type) {
        this.rebuild(undefined, true, type);
      }
    },

    summary: function summary() {
      var small = this.$vuetify.breakpoint.xs;

      if (small) {
        return this.calendar.start.format(this.formats.xs);
      }

      var large = this.$vuetify.breakpoint.mdAndUp;

      return this.calendar.summary(false, !large, false, !large);
    },
    todayDate: function todayDate() {
      return this.$dayspan.today.format(this.formats.today);
    },
    nextLabel: function nextLabel() {
      return this.labels.next(this.currentType);
    },
    prevLabel: function prevLabel() {
      return this.labels.prev(this.currentType);
    },
    toolbarStyle: function toolbarStyle() {
      var large = this.$vuetify.breakpoint.lgAndUp;

      return large ? this.styles.toolbar.large : this.styles.toolbar.small;
    },
    hasCreatePopover: function hasCreatePopover() {
      return !!this.$scopedSlots.eventCreatePopover;
    },
    canAddDay: function canAddDay() {
      return this.$dayspan.features.addDay && !this.readOnly && !this.$dayspan.readOnly;
    },
    canAddTime: function canAddTime() {
      return this.$dayspan.features.addTime && !this.readOnly && !this.$dayspan.readOnly;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (!this.$dayspan.promptOpen) {
      this.$dayspan.promptOpen = function (question, callback) {
        _this2.promptVisible = false;
        _this2.promptQuestion = question;
        _this2.promptCallback = callback;
        _this2.promptVisible = true;
      };
    }
  },


  methods: {
    setState: function setState(state) {
      state.eventSorter = state.listTimes ? __WEBPACK_IMPORTED_MODULE_0_dayspan__["Sorts"].List([__WEBPACK_IMPORTED_MODULE_0_dayspan__["Sorts"].FullDay, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Sorts"].Start]) : __WEBPACK_IMPORTED_MODULE_0_dayspan__["Sorts"].Start;

      this.calendar.set(state);

      this.triggerChange();
    },
    applyEvents: function applyEvents() {
      if (this.events) {
        this.calendar.removeEvents();
        this.calendar.addEvents(this.events);
      }
    },
    isType: function isType(type, aroundDay) {
      var cal = this.calendar;

      return cal.type === type.type && cal.size === type.size && (!aroundDay || cal.span.matchesDay(aroundDay));
    },
    rebuild: function rebuild(aroundDay, force, forceType) {
      var type = forceType || this.currentType || this.types[2];

      if (this.isType(type, aroundDay) && !force) {
        return;
      }

      var input = {
        type: type.type,
        size: type.size,
        around: aroundDay,
        eventsOutside: true,
        preferToday: false,
        listTimes: type.listTimes,
        updateRows: type.updateRows,
        updateColumns: type.listTimes,
        fill: !type.listTimes,
        otherwiseFocus: type.focus,
        repeatCovers: type.repeat
      };

      this.setState(input);
    },
    next: function next() {
      this.calendar.unselect().next();

      this.triggerChange();
    },
    prev: function prev() {
      this.calendar.unselect().prev();

      this.triggerChange();
    },
    setToday: function setToday() {
      this.rebuild(this.$dayspan.today);
    },
    viewDay: function viewDay(day) {
      this.rebuild(day, false, this.types[0]);
    },
    edit: function edit(calendarEvent) {
      var eventDialog = this.$refs.eventDialog;

      eventDialog.edit(calendarEvent);
    },
    editPlaceholder: function editPlaceholder(createEdit) {
      var placeholder = createEdit.calendarEvent;
      var details = createEdit.details;
      var eventDialog = this.$refs.eventDialog;
      var calendar = this.$refs.calendar;

      eventDialog.addPlaceholder(placeholder, details);
      eventDialog.$once('close', calendar.clearPlaceholder);
    },
    add: function add(day) {
      if (!this.canAddDay) {
        return;
      }

      var eventDialog = this.$refs.eventDialog;
      var calendar = this.$refs.calendar;
      var useDialog = !this.hasCreatePopover;

      calendar.addPlaceholder(day, true, useDialog);

      if (useDialog) {
        eventDialog.add(day);
        eventDialog.$once('close', calendar.clearPlaceholder);
      }
    },
    addAt: function addAt(dayHour) {
      if (!this.canAddTime) {
        return;
      }

      var eventDialog = this.$refs.eventDialog;
      var calendar = this.$refs.calendar;
      var useDialog = !this.hasCreatePopover;
      var at = dayHour.day.withHour(dayHour.hour);

      calendar.addPlaceholder(at, false, useDialog);

      if (useDialog) {
        eventDialog.addAt(dayHour.day, dayHour.hour);
        eventDialog.$once('close', calendar.clearPlaceholder);
      }
    },
    addToday: function addToday() {
      if (!this.canAddDay) {
        return;
      }

      var eventDialog = this.$refs.eventDialog;
      var calendar = this.$refs.calendar;
      var useDialog = !this.hasCreatePopover || !calendar;

      var day = this.$dayspan.today;

      if (!this.calendar.filled.matchesDay(day)) {
        var first = this.calendar.days[0];
        var last = this.calendar.days[this.calendar.days.length - 1];
        var firstDistance = Math.abs(first.currentOffset);
        var lastDistance = Math.abs(last.currentOffset);

        day = firstDistance < lastDistance ? first : last;
      }

      calendar && calendar.addPlaceholder(day, true, useDialog);

      if (useDialog) {
        eventDialog.add(day);

        calendar && eventDialog.$once('close', calendar.clearPlaceholder);
      }
    },
    handleAdd: function handleAdd(addEvent) {
      var eventDialog = this.$refs.eventDialog;
      var calendar = this.$refs.calendar;

      addEvent.handled = true;

      if (!this.hasCreatePopover) {
        if (addEvent.placeholder.fullDay) {
          eventDialog.add(addEvent.span.start, addEvent.span.days(__WEBPACK_IMPORTED_MODULE_0_dayspan__["Op"].UP));
        } else {
          eventDialog.addSpan(addEvent.span);
        }

        eventDialog.$once('close', addEvent.clearPlaceholder);
      } else {
        calendar.placeholderForCreate = true;
      }
    },
    handleMove: function handleMove(moveEvent) {
      var _this3 = this;

      var calendarEvent = moveEvent.calendarEvent;
      var target = moveEvent.target;
      var targetStart = target.start;
      var sourceStart = calendarEvent.time.start;
      var schedule = calendarEvent.schedule;
      var options = [];

      moveEvent.handled = true;

      var callbacks = {
        cancel: function cancel() {
          moveEvent.clearPlaceholder();
        },
        single: function single() {
          calendarEvent.move(targetStart);
          _this3.eventsRefresh();
          moveEvent.clearPlaceholder();

          _this3.$emit('event-update', calendarEvent.event);
        },
        instance: function instance() {
          calendarEvent.move(targetStart);
          _this3.eventsRefresh();
          moveEvent.clearPlaceholder();

          _this3.$emit('event-update', calendarEvent.event);
        },
        duplicate: function duplicate() {
          schedule.setExcluded(targetStart, false);
          _this3.eventsRefresh();
          moveEvent.clearPlaceholder();

          _this3.$emit('event-update', calendarEvent.event);
        },
        all: function all() {
          schedule.moveTime(sourceStart.asTime(), targetStart.asTime());
          _this3.eventsRefresh();
          moveEvent.clearPlaceholder();

          _this3.$emit('event-update', calendarEvent.event);
        }
      };

      options.push({
        text: this.labels.moveCancel,
        callback: callbacks.cancel
      });

      if (schedule.isSingleEvent()) {
        options.push({
          text: this.labels.moveSingleEvent,
          callback: callbacks.single
        });

        if (this.$dayspan.features.moveDuplicate) {
          options.push({
            text: this.labels.moveDuplicate,
            callback: callbacks.duplicate
          });
        }
      } else {
        if (this.$dayspan.features.moveInstance) {
          options.push({
            text: this.labels.moveOccurrence,
            callback: callbacks.instance
          });
        }

        if (this.$dayspan.features.moveDuplicate) {
          options.push({
            text: this.labels.moveDuplicate,
            callback: callbacks.duplicate
          });
        }

        if (this.$dayspan.features.moveAll && !schedule.isFullDay() && targetStart.sameDay(sourceStart)) {
          options.push({
            text: this.labels.moveAll,
            callback: callbacks.all
          });
        }
      }

      this.options = options;
      this.optionsVisible = true;
    },
    chooseOption: function chooseOption(option) {
      if (option) {
        option.callback();
      }

      this.optionsVisible = false;
    },
    choosePrompt: function choosePrompt(yes) {
      this.promptCallback(yes);
      this.promptVisible = false;
    },
    eventFinish: function eventFinish(ev) {
      this.triggerChange();
    },
    eventsRefresh: function eventsRefresh() {
      this.calendar.refreshEvents();

      this.triggerChange();
    },
    triggerChange: function triggerChange() {
      this.$emit('change', {
        calendar: this.calendar
      });
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEvent',

  props: {
    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    index: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().index;
      }
    },

    popoverProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'popoverProps');
      },
      default: function _default() {
        return this.$dsDefaults().popoverProps;
      }
    },

    isPlaceholderWithDay: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    }
  },

  computed: {
    style: function style() {
      return this.isPlaceholderWithDay ? this.$dayspan.getStylePlaceholderFull(this.details, this.calendarEvent, this.index, this.isPlaceholderWithDay) : this.$dayspan.getStyleFull(this.details, this.calendarEvent, this.index);
    },
    contentClass: function contentClass() {
      return this.$dayspan.fullscreenPopovers ? 'ds-fullscreen' : '';
    },
    sameDayEvents: function sameDayEvents() {
      return this.calendarEvent.event.schedule.iterateSpans(this.calendarEvent.day, true).list();
    },
    hasPrefix: function hasPrefix() {
      return !this.calendarEvent.fullDay && this.sameDayEvents.length > 0;
    },
    hasIcon: function hasIcon() {
      return !!(this.$dayspan.supports.icon && this.details.icon);
    },
    getPrefix: function getPrefix() {
      return this.$dayspan.getPrefix(this.calendarEvent, this.sameDayEvents);
    },
    showName: function showName() {
      return this.isPlaceholderWithDay ? this.isPlaceholderWithDay.sameDay(this.calendarEvent.start) : this.calendarEvent.starting || this.calendar && !this.calendar.filled.contains(this.calendarEvent.time.start) && this.calendar.filled.start.sameDay(this.calendarEvent.day);
    },
    hasPopover: function hasPopover() {
      return !!this.$scopedSlots.eventPopover;
    },
    details: function details() {
      return this.calendarEvent.event.data;
    }
  },

  data: function data(vm) {
    return {
      menu: false
    };
  },

  methods: {
    close: function close() {
      this.menu = false;
    },
    edit: function edit() {
      if (this.handlesEvents()) {
        this.$emit('edit', this.calendarEvent);
      }
    },
    editCheck: function editCheck($event) {
      if (this.handlesEvents($event)) {
        if (!this.hasPopover) {
          this.edit();
        } else {
          this.menu = !this.menu;
        }
      }
    },
    mouseEnterEvent: function mouseEnterEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-enter-event', this.getEvent('mouse-enter-event', $event));
      }
    },
    mouseLeaveEvent: function mouseLeaveEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-leave-event', this.getEvent('mouse-leave-event', $event));
      }
    },
    mouseDownEvent: function mouseDownEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-down-event', this.getEvent('mouse-down-event', $event));
      }
    },
    mouseUpEvent: function mouseUpEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-up-event', this.getEvent('mouse-up-event', $event));
      }
    },
    handlesEvents: function handlesEvents($event) {
      var handles = !this.isPlaceholderWithDay;

      if (handles && $event) {
        $event.stopPropagation();
      }

      return handles;
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        details: this.details,
        left: $event.button === 0,
        right: $event.button === 1,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventChip',

  props: {
    time: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    canExclude: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().canExclude;
      }
    },

    colors: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'colors');
      },
      default: function _default() {
        return this.$dsDefaults().colors;
      }
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    }
  },

  computed: {
    aroundDay: function aroundDay() {
      return this.day || this.$dayspan.today;
    },
    same: function same() {
      return this.aroundDay.sameDay(this.time);
    },
    background: function background() {
      return this.same ? this.colors.sameBackground : '';
    },
    foreground: function foreground() {
      return this.same ? this.colors.sameForeground : '';
    },
    text: function text() {
      return this.time.format(this.formats.fullDay);
    }
  },

  methods: {
    exclude: function exclude() {
      this.$emit('exclude', this.time);
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dayspan__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventCreatePopover',

  props: {
    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_1_dayspan__["CalendarEvent"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_1_dayspan__["Calendar"]
    },

    close: {
      type: Function
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    },

    icons: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'icons');
      },
      default: function _default() {
        return this.$dsDefaults().icons;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    prompts: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'prompts');
      },
      default: function _default() {
        return this.$dsDefaults().prompts;
      }
    },

    busyOptions: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().busyOptions;
      }
    }
  },

  computed: {
    slotData: function slotData() {
      return {
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        close: this.close,
        details: this.details
      };
    },
    classes: function classes() {
      return {
        'ds-event-cancelled': this.calendarEvent.cancelled
      };
    },
    styleHeader: function styleHeader() {
      return {
        backgroundColor: this.details.color,
        color: this.details.forecolor
      };
    },
    styleText: function styleText() {
      return {
        color: this.details.forecolor
      };
    },
    startDate: function startDate() {
      return this.calendarEvent.start.format(this.formats.start);
    },
    busyness: function busyness() {
      return this.details.busy ? this.labels.busy : this.labels.free;
    },
    isValid: function isValid() {
      return this.$dayspan.isValidEvent(this.details, this.calendarEvent.schedule, this.calendarEvent);
    },
    occurs: function occurs() {
      return this.$dayspan.getEventOccurrence(this.calendarEvent.schedule, this.calendarEvent.start, this.labels, this.formats);
    }
  },

  data: function data(vm) {
    return {
      details: vm.buildDetails()
    };
  },

  methods: {
    edit: function edit() {
      var ev = this.getEvent('create-edit');

      this.$emit('create-edit', ev);

      this.finishEvent(ev);
    },
    save: function save() {
      var ev = this.getEvent('creating');

      this.$emit('creating', ev);

      if (!ev.handled && ev.details && ev.calendarEvent) {
        ev.created = ev.calendarEvent.event;

        this.$dayspan.setEventDetails(ev.details, ev.created.data, ev.created, ev.calendarEvent);

        if (ev.calendar) {
          ev.calendar.addEvent(ev.created);
          ev.added = true;
        }

        this.$emit('created', ev);

        if (ev.calendar && ev.refresh) {
          ev.calendar.refreshEvents();
        }

        ev.handled = true;

        this.$emit('event-create', ev.created);
      }

      this.finishEvent(ev);
    },
    finishEvent: function finishEvent(ev) {
      if (ev.close) {
        this.close();

        this.$emit('create-popover-closed', ev);
      }
    },
    buildDetails: function buildDetails() {
      var details = this.$dayspan.copyEventDetails(this.calendarEvent.event.data);

      details.title = '';

      return details;
    },
    getEvent: function getEvent(type) {
      var _fn$extend;

      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_1_dayspan__["Functions"].extend((_fn$extend = {

        type: type,
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        close: this.close,
        details: this.details,
        handled: false,
        added: false,
        refresh: true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_fn$extend, 'close', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_fn$extend, '$vm', this), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_fn$extend, '$element', this.$el), _fn$extend), extra);
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventPlaceholder',

  props: {
    placeholder: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    index: {
      type: Number,
      default: 0
    },

    popoverProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'popoverProps');
      },
      default: function _default() {
        return this.$dsDefaults().popoverProps;
      }
    }
  },

  computed: {
    hasPopover: function hasPopover() {
      return !!this.$scopedSlots.eventCreatePopover;
    },
    contentClass: function contentClass() {
      return this.$dayspan.fullscreenPopovers ? 'ds-fullscreen' : '';
    },
    isStart: function isStart() {
      return this.placeholder.day.sameDay(this.day);
    },
    autoOpen: function autoOpen() {
      return this.hasPopover && this.placeholderForCreate && this.isStart;
    }
  },

  data: function data(vm) {
    return {
      menu: false
    };
  },

  watch: {
    menu: 'triggerClearPlaceholder',
    placeholderForCreate: 'openPopover'
  },

  mounted: function mounted() {
    if (this.autoOpen) {
      this.menu = true;
    }
  },


  methods: {
    close: function close() {
      this.menu = false;
    },
    openPopover: function openPopover(open) {
      if (this.isStart) {
        this.menu = open;
      }
    },
    triggerClearPlaceholder: function triggerClearPlaceholder(open) {
      if (!open) {
        this.$emit('clear-placeholder');
      }
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventPopover',

  props: {
    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    edit: {
      type: Function
    },

    allowEditOnReadOnly: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowEditOnReadOnly;
      }
    },

    close: {
      type: Function
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  computed: {
    slotData: function slotData() {
      return {
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        edit: this.edit,
        close: this.close,
        details: this.details,
        readOnly: this.readOnly
      };
    },
    classes: function classes() {
      return {
        'ds-event-cancelled': this.calendarEvent.cancelled
      };
    },
    styleHeader: function styleHeader() {
      return {
        backgroundColor: this.details.color,
        color: this.details.forecolor
      };
    },
    styleButton: function styleButton() {
      return {
        color: this.details.forecolor
      };
    },
    startDate: function startDate() {
      return this.calendarEvent.start.format(this.formats.start);
    },
    busyness: function busyness() {
      return this.details.busy ? this.labels.busy : this.labels.free;
    },
    hasBusy: function hasBusy() {
      return typeof this.details.busy === 'boolean';
    },
    occurs: function occurs() {
      return this.$dayspan.getEventOccurrence(this.calendarEvent.schedule, this.calendarEvent.start, this.labels, this.formats);
    },
    details: function details() {
      return this.calendarEvent.event.data;
    },
    allowEdit: function allowEdit() {
      return this.allowEditOnReadOnly || !this.isReadOnly;
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly || this.details.readonly;
    }
  },

  data: function data(vm) {
    return {};
  },

  methods: {}
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventTime',

  props: {
    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    popoverProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'popoverProps');
      },
      default: function _default() {
        return this.$dsDefaults().popoverProps;
      }
    },

    isPlaceholderWithDay: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    }
  },

  computed: {
    style: function style() {
      return this.isPlaceholderWithDay ? this.$dayspan.getStylePlaceholderTimed(this.details, this.calendarEvent, this.isPlaceholderWithDay) : this.$dayspan.getStyleTimed(this.details, this.calendarEvent);
    },
    showName: function showName() {
      return this.calendarEvent.starting || this.calendar && !this.calendar.span.contains(this.calendarEvent.time.start);
    },
    hasPopover: function hasPopover() {
      return !!this.$scopedSlots.eventPopover;
    },
    hasIcon: function hasIcon() {
      return !!(this.$dayspan.supports.icon && this.details.icon);
    },
    contentClass: function contentClass() {
      return this.$dayspan.fullscreenPopovers ? 'ds-fullscreen' : '';
    },
    details: function details() {
      return this.calendarEvent.event.data;
    }
  },

  data: function data(vm) {
    return {
      menu: false
    };
  },

  methods: {
    close: function close() {
      this.menu = false;
    },
    edit: function edit() {
      if (this.handlesEvents()) {
        this.$emit('edit', this.calendarEvent);
      }
    },
    editCheck: function editCheck($event) {
      if (this.handlesEvents($event)) {
        if (!this.hasPopover) {
          this.edit();
        } else {
          this.menu = !this.menu;
        }
      }
    },
    mouseEnterEvent: function mouseEnterEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-enter-event', this.getEvent('mouse-enter-event', $event));
      }
    },
    mouseLeaveEvent: function mouseLeaveEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-leave-event', this.getEvent('mouse-leave-event', $event));
      }
    },
    mouseDownEvent: function mouseDownEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-down-event', this.getEvent('mouse-down-event', $event));
      }
    },
    mouseUpEvent: function mouseUpEvent($event) {
      if (this.handlesEvents($event)) {
        this.$emit('mouse-up-event', this.getEvent('mouse-up-event', $event));
      }
    },
    handlesEvents: function handlesEvents($event) {
      var handles = !this.isPlaceholderWithDay;

      if (handles && $event) {
        $event.stopPropagation();
      }

      return handles;
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        calendarEvent: this.calendarEvent,
        calendar: this.calendar,
        details: this.details,
        offset: this.getRelativeTimeAt($event),
        left: $event.button === 0,
        right: $event.button === 1,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    },
    getRelativeTimeAt: function getRelativeTimeAt($event) {
      var bounds = this.$el.getBoundingClientRect();
      var y = ($event.clientY - bounds.y) / this.$dayspan.dayHeight;
      var millis = y * __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_DAY;

      return millis;
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsCalendarEventTimePlaceholder',

  props: {
    placeholder: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    popoverProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'popoverProps');
      },
      default: function _default() {
        return this.$dsDefaults().popoverProps;
      }
    }
  },

  computed: {
    hasPopover: function hasPopover() {
      return !!this.$scopedSlots.eventCreatePopover;
    },
    contentClass: function contentClass() {
      return this.$dayspan.fullscreenPopovers ? 'ds-fullscreen' : '';
    },
    isStart: function isStart() {
      return this.placeholder.day.sameDay(this.day);
    },
    autoOpen: function autoOpen() {
      return this.hasPopover && this.placeholderForCreate && this.isStart;
    }
  },

  data: function data(vm) {
    return {
      menu: false
    };
  },

  watch: {
    menu: 'triggerClearPlaceholder',
    placeholderForCreate: 'openPopover'
  },

  mounted: function mounted() {
    if (this.autoOpen) {
      this.menu = true;
    }
  },


  methods: {
    close: function close() {
      this.menu = false;
    },
    openPopover: function openPopover(open) {
      if (this.isStart) {
        this.menu = open;
      }
    },
    triggerClearPlaceholder: function triggerClearPlaceholder(open) {
      if (!open) {
        this.$emit('clear-placeholder');
      }
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsDay',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    }
  },

  computed: {
    classesDay: function classesDay() {
      return {
        'ds-today': this.day.currentDay,
        'ds-first-day-day': this.day.dayOfMonth === 1,
        'ds-out-calendar': !this.day.inCalendar
      };
    },
    classesHeader: function classesHeader() {
      return {
        'ds-out-calendar': !this.day.inCalendar
      };
    },
    classesDayOfMonth: function classesDayOfMonth() {
      return {
        'ds-today-dom': this.day.currentDay
      };
    },
    showMonth: function showMonth() {
      return this.day.dayOfMonth === 1;
    },
    dayOfMonth: function dayOfMonth() {
      return this.day.dayOfMonth;
    },
    month: function month() {
      return this.day.format(this.formats.month);
    },
    hasPlaceholder: function hasPlaceholder() {
      return this.placeholder && this.placeholder.time.matchesDay(this.day);
    },
    visibleEvents: function visibleEvents() {
      return this.day.events.filter(this.isVisible);
    }
  },

  methods: {
    isVisible: function isVisible(calendarEvent) {
      if (this.$dayspan.features.hideOnMove && this.placeholder && this.placeholder.event === calendarEvent.event) {
        return false;
      }

      return true;
    },
    add: function add() {
      this.$emit('add', this.day);
    },
    viewDay: function viewDay(event) {
      this.$emit('view-day', this.day);
    },
    mouseEnterDay: function mouseEnterDay($event) {
      this.$emit('mouse-enter-day', this.day);
    },
    mouseLeaveDay: function mouseLeaveDay($event) {
      this.$emit('mouse-leave-day', this.day);
    },
    mouseMoveDay: function mouseMoveDay($event) {
      this.$emit('mouse-move-day', this.getEvent('mouse-move-day', $event));
    },
    mouseDownDay: function mouseDownDay($event) {
      this.$emit('mouse-down-day', this.getEvent('mouse-down-day', $event));
    },
    mouseUpDay: function mouseUpDay($event) {
      this.$emit('mouse-up-day', this.getEvent('mouse-up-day', $event));
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        day: this.day,
        calendar: this.calendar,
        left: $event.button === 0 && $event.buttons > 0,
        right: $event.button === 1 && $event.buttons > 0,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsDayPicker',

  props: {
    span: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["DaySpan"]
    },

    highlightSpan: {
      type: Boolean,
      default: false
    },

    weekdays: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().weekdays;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      month: vm.getMonth()
    };
  },

  computed: {
    summary: function summary() {
      return this.month ? this.month.summary(false, false, false, false) : '';
    }
  },

  watch: {
    span: {
      deep: true,
      handler: 'resetMonth'
    }
  },

  methods: {
    isHighlighted: function isHighlighted(day) {
      return this.highlightSpan && this.span.matchesDay(day);
    },
    getMonthStart: function getMonthStart() {
      return this.span && this.span.start ? this.span.start : this.$dayspan.today;
    },
    resetMonth: function resetMonth() {
      if (!this.span.matchesMonth(this.month.start)) {
        this.month = this.getMonth();
      }
    },
    getMonth: function getMonth() {
      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"].months(1, this.getMonthStart(), 0, { fill: true, minimumSize: 42 });
    },
    pick: function pick(day) {
      this.$emit('picked', day);
    },
    prev: function prev() {
      var ev = this.getEvent('prev', { next: false, prev: true });

      this.$emit('prev', ev);

      if (!ev.handled) {
        ev.month.prev();
        ev.handled = true;
      }

      this.$emit('change', ev);
    },
    next: function next() {
      var ev = this.getEvent('next', { next: true, prev: false });

      this.$emit('next', ev);

      if (!ev.handled) {
        ev.month.next();
        ev.handled = true;
      }

      this.$emit('change', ev);
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        span: this.span,
        month: this.month,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsDayRow',

  props: {
    days: {
      required: true,
      type: Array
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    }
  },

  methods: {}
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsDayTimes',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarDay"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classesDay: function classesDay() {
      return {
        'ds-day-today': this.day.currentDay,
        'ds-day-past': this.day.currentOffset < 0,
        'ds-day-future': this.day.currentOffset > 0
      };
    },
    nowLine: function nowLine() {
      return this.$dayspan.getStyleNow();
    },
    hasPlaceholder: function hasPlaceholder() {
      return this.placeholder && !this.placeholder.fullDay && this.placeholder.time.matchesDay(this.day);
    }
  },

  methods: {
    isVisible: function isVisible(calendarEvent) {
      if (calendarEvent.fullDay) {
        return false;
      }

      if (this.$dayspan.features.hideOnMove && this.placeholder && this.placeholder.event === calendarEvent.event) {
        return false;
      }

      return true;
    },
    addAt: function addAt(hour) {
      this.$emit('add-at', {
        day: this.day,
        hour: hour - 1
      });
    },
    mouseEnterDay: function mouseEnterDay($event) {
      this.$emit('mouse-enter-day', this.day);
    },
    mouseLeaveDay: function mouseLeaveDay($event) {
      this.$emit('mouse-leave-day', this.day);
    },
    mouseMove: function mouseMove($event) {
      var time = this.getTimeAt($event, this.$dayspan.rounding.move);
      var timeDrag = this.getTimeAt($event, this.$dayspan.rounding.add, true);
      var ev = this.getEvent('mouse-move', $event, { time: time, timeDrag: timeDrag });

      this.$emit('mouse-move', ev);
    },
    mouseDown: function mouseDown($event) {
      var time = this.getTimeAt($event, this.$dayspan.rounding.add);
      var ev = this.getEvent('mouse-down', $event, { time: time });

      this.$emit('mouse-down', ev);
    },
    mouseUp: function mouseUp($event) {
      var time = this.getTimeAt($event, this.$dayspan.rounding.add, true);
      var ev = this.getEvent('mouse-up', $event, { time: time });

      this.$emit('mouse-up', ev);
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        day: this.day,
        left: $event.button === 0 && $event.buttons > 0,
        right: $event.button === 1 && $event.buttons > 0,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    },
    getTimeAt: function getTimeAt($event, roundTo, roundUp) {
      var bounds = this.$el.getBoundingClientRect();
      var y = ($event.clientY - bounds.y) / bounds.height;
      var millis = Math.round(__WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_DAY * y);
      var time = this.day.start().relative(millis);

      if (roundTo) {
        time = this.$dayspan.roundTime(time, roundTo, roundUp);
      }

      return time;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsDaysView',

  props: {
    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    scrollToFirst: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().scrollToFirst;
      }
    },

    scrollBuffer: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().scrollBuffer;
      }
    },

    hours: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().hours;
      }
    }
  },

  computed: {
    dayHeight: function dayHeight() {
      return {
        height: this.$dayspan.dayHeight + 'px'
      };
    },
    hourClasses: function hourClasses() {
      var currentHour = this.$dayspan.now.hour;

      return this.hours.map(function (hour, index) {
        return {
          'ds-same-hour': index === currentHour,
          'ds-past-hour': index < currentHour
        };
      });
    }
  },

  data: function data(vm) {
    return {
      scrollPush: 0
    };
  },

  watch: {
    'calendar.start': 'scrollToEvent'
  },

  mounted: function mounted() {
    this.scrollToEvent();
    this.scrollPush = this.getScrollPush();
  },


  methods: {
    scrollToEvent: function scrollToEvent() {
      if (this.scrollToFirst) {
        var last = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MINUTES_IN_DAY;
        var first = this.calendar.iterateDays().reduce(last, function (day, first) {
          return day.iterateEvents().reduce(first, function (event, first) {
            return Math.min(first, event.start.hour * __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MINUTES_IN_HOUR + event.start.minute);
          }, function (event) {
            return !event.fullDay;
          });
        });

        if (last !== first) {
          var dayDelta = (first - this.scrollBuffer) / __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MINUTES_IN_HOUR;
          var dayPixels = dayDelta * this.$dayspan.hourHeight;

          this.$refs.scrollArea.scrollTop = Math.floor(dayPixels);
        }
      }
    },
    getScrollPush: function getScrollPush() {
      var area = this.$refs.scrollArea;
      var pane = this.$refs.pane;

      return area && pane ? area.offsetWidth - pane.offsetWidth : 0;
    }
  }

});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsEvent',

  props: {
    targetSchedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    targetDetails: {
      type: Object,
      required: true
    },

    calendarEvent: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    hasTitle: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasTitle;
      }
    },

    hasCancel: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasCancel;
      }
    },

    hasSave: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasSave;
      }
    },

    hasTabs: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasTabs;
      }
    },

    hasDetails: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasDetails;
      }
    },

    hasForecast: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasForecast;
      }
    },

    hasExclusions: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasExclusions;
      }
    },

    hasInclusions: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasInclusions;
      }
    },

    hasCancelled: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasCancelled;
      }
    },

    busyOptions: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().busyOptions;
      }
    }
  },

  data: function data(vm) {
    return {
      tab: 'details',
      schedule: new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"](),
      details: vm.$dayspan.getDefaultEventDetails()
    };
  },

  watch: {
    targetSchedule: {
      handler: 'updateSchedule',
      immediate: true
    },

    targetDetails: {
      handler: 'updateDetails',
      immediate: true
    }
  },

  computed: {
    slotData: function slotData() {
      return {
        targetSchedule: this.targetSchedule,
        targetDetails: this.targetDetails,
        schedule: this.schedule,
        details: this.details,
        busyOptions: this.busyOptions,
        day: this.day,
        calendar: this.calendar,
        calendarEvent: this.calendarEvent,
        labels: this.labels,
        readOnly: this.readOnly
      };
    },
    classes: function classes() {
      return {
        'ds-has-cancel': this.hasCancel,
        'ds-event-small': this.$vuetify.breakpoint.smAndDown
      };
    },
    canSave: function canSave() {
      return this.$dayspan.isValidEvent(this.details, this.schedule, this.calenderEvent);
    },
    repeats: function repeats() {
      return !this.schedule.isSingleEvent();
    },
    showTitle: function showTitle() {
      return this.$dayspan.supports.title && this.hasTitle;
    },
    showCancels: function showCancels() {
      return this.$dayspan.features.cancel && this.repeats && this.hasCancelled && !this.schedule.cancel.isEmpty();
    },
    showForecast: function showForecast() {
      return this.$dayspan.features.forecast && this.repeats && this.hasForecast;
    },
    showExclusions: function showExclusions() {
      return this.$dayspan.features.exclude && this.repeats && this.hasExclusions && !this.schedule.exclude.isEmpty();
    },
    showInclusions: function showInclusions() {
      return this.$dayspan.features.include && this.repeats && this.hasInclusions && !this.schedule.include.isEmpty();
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    save: function save() {
      var ev = this.getEvent('save');

      this.$emit('save', ev);

      if (!ev.handled) {
        if (ev.target && ev.schedule) {
          ev.target.set(ev.schedule);
        }

        if (ev.calendarEvent) {
          this.$dayspan.setEventDetails(ev.details, ev.targetDetails, ev.calendarEvent.event, ev.calendarEvent);

          this.$emit('update', ev);

          this.$emit('event-update', ev.calendarEvent.event);
        } else if (ev.create) {
          ev.created = this.$dayspan.createEvent(ev.details, ev.schedule);

          if (ev.calendar) {
            ev.calendar.addEvent(ev.created);
            ev.added = true;
          }

          this.$emit('create', ev);
        }

        if (ev.calendar && ev.refresh) {
          ev.calendar.refreshEvents();
        }

        ev.handled = true;

        if (ev.created) {
          this.$emit('event-create', ev.created);
        }
      }

      this.$emit('saved', ev);
    },
    actioned: function actioned(ev) {
      this.$emit('actioned', ev);
    },
    cancel: function cancel() {
      this.$emit('cancel', this.getEvent('cancel'));
    },
    updateSchedule: function updateSchedule(schedule) {
      this.schedule = schedule.clone();
      this.tab = 'details';
    },
    updateDetails: function updateDetails(details) {
      this.details = this.$dayspan.copyEventDetails(details);
      this.tab = 'details';
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        day: this.day,
        schedule: this.schedule,
        target: this.targetSchedule,
        details: this.details,
        targetDetails: this.targetDetails,
        calendar: this.calendar,
        calendarEvent: this.calendarEvent,
        handled: false,
        refresh: true,
        create: true,
        added: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsEventDialog',

  props: {
    calendar: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    dialogProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'dialogProps');
      },
      default: function _default() {
        return this.$dsDefaults().dialogProps;
      }
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: function data(vm) {
    return {
      open: false,
      calendarEvent: null,
      details: null,
      schedule: null,
      day: null
    };
  },

  computed: {},

  methods: {
    addToday: function addToday() {
      this.add(this.$dayspan.today);
    },
    add: function add(day, days) {
      this.addSchedule(day, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forDay(day, days));
    },
    addAt: function addAt(day, hour) {
      this.addSchedule(day, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forTime(day, hour));
    },
    addSpan: function addSpan(span) {
      this.addSchedule(span.start, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"].forSpan(span));
    },
    addPlaceholder: function addPlaceholder(placeholder, details) {
      this.addSchedule(placeholder.start, placeholder.schedule, details || placeholder.event.data);
    },
    addSchedule: function addSchedule(day, schedule, details) {
      this.day = day;
      this.calendarEvent = null;
      this.details = details || this.$dayspan.getDefaultEventDetails();
      this.schedule = schedule;

      this.finishOpen();
    },
    edit: function edit(calendarEvent) {
      this.day = calendarEvent.start;
      this.calendarEvent = calendarEvent;
      this.details = calendarEvent.event.data || this.$dayspan.getDefaultEventDetails();
      this.schedule = calendarEvent.schedule;

      this.finishOpen();
    },
    finishOpen: function finishOpen() {
      var ev = this.getEvent('open');

      this.$emit('open', ev);

      if (ev.open) {
        this.open = true;
      }
    },
    eventCreate: function eventCreate(ev) {
      this.$emit('event-create', ev);
    },
    eventUpdate: function eventUpdate(ev) {
      this.$emit('event-update', ev);
    },
    eventRemove: function eventRemove(ev) {
      this.$emit('event-remove', ev);
    },
    actioned: function actioned(ev) {
      ev.hide = true;
      this.$emit('actioned', ev);
      this.finishClose(ev);
    },
    cancel: function cancel(ev) {
      ev.hide = true;
      this.$emit('cancel', ev);
      this.finishClose(ev);
    },
    saved: function saved(ev) {
      ev.hide = true;
      this.$emit('saved', ev);
      this.finishClose(ev);
    },
    finishClose: function finishClose(ev) {
      if (ev.hide) {
        this.open = false;
        this.$emit('close', ev);
      }

      this.schedule = null;
      this.details = null;
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        day: this.day,
        schedule: this.schedule,
        calendar: this.calendar,
        calendarEvent: this.calendarEvent,
        handled: false,
        open: true,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsGestures',

  props: {
    minDistance: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().minDistance;
      }
    },
    maxDistance: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().maxDistance;
      }
    },
    maxWander: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().maxWander;
      }
    }
  },

  methods: {
    start: function start($event) {
      this.starting = this.getPoint($event);
    },
    move: function move($event) {
      this.checkGesture(this.getPoint($event), this.maxDistance);
    },
    end: function end($event) {
      this.checkGesture(this.getPoint($event), this.minDistance);
    },
    checkGesture: function checkGesture(point, threshold) {
      var start = this.starting;

      if (!start) {
        return false;
      }

      var dx = point.x - start.x;
      var dy = point.y - start.y;
      var dSq = dx * dx;

      if (dSq > threshold * threshold) {
        var distance = Math.sqrt(dSq);
        var adx = dx < 0 ? -dx : dx;
        var ady = dy < 0 ? -dy : dy;

        // more horizontal than vertical
        if (adx > ady) {
          // check wander
          if (adx * this.maxWander > ady) {
            // towards left
            if (dx < 0) {
              this.$emit('swipeleft', adx);
            }
            // towards right
            else {
                this.$emit('swiperight', adx);
              }

            this.$emit('swipex', dx);
          }
        }
        // more vertical than horizontal
        else {
            // check wander
            if (ady * this.maxWander > adx) {
              // towards top
              if (dy < 0) {
                this.$emit('swipeup', ady);
              }
              // towards bottom
              else {
                  this.$emit('swipedown', ady);
                }

              this.$emit('swipey', dy);
            }
          }

        this.starting = null;
      }
    },
    getPoint: function getPoint($event) {
      var touch = $event.touches[0] || $event.changedTouches[0];

      return {
        x: touch.clientX,
        y: touch.clientY
      };
    }
  }

});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsIdentifierChip',

  props: {
    identifier: {
      required: true,
      validator: function validator(x) {
        return typeof x === 'string' || typeof x === 'number';
      }
    },

    description: {
      type: String,
      default: function _default() {
        return this.$dsDefaults().description;
      }
    },

    short: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().short;
      }
    },

    canRemove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().canRemove;
      }
    }
  },

  computed: {
    text: function text() {
      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Identifier"].find(this.identifier).describe(this.identifier, this.short);
    }
  },

  methods: {
    remove: function remove() {
      this.$emit('remove', this.identifier);
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsSchedule',

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    allowsRange: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowsRange;
      }
    }
  },

  data: function data(vm) {
    return {};
  },

  computed: {
    showRange: function showRange() {
      return this.allowsRange && !this.schedule.isSingleEvent();
    },
    classes: function classes() {
      return {
        'ds-schedule-small': this.$vuetify.breakpoint.smAndDown
      };
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    custom: function custom() {
      this.$refs.customScheduler.edit(this.schedule, this.day);
    },
    setType: function setType(type) {
      this.$emit('type', type);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleActions',

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    calendarEvent: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    calendar: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    allowRemove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowRemove;
      }
    },

    allowExclude: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowExclude;
      }
    },

    allowCancel: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowCancel;
      }
    },

    allowUncancel: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowUncancel;
      }
    },

    allowMove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowMove;
      }
    },

    allowInclude: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowInclude;
      }
    },

    allowSetStart: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowSetStart;
      }
    },

    allowSetEnd: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().allowSetEnd;
      }
    }
  },

  data: function data(vm) {
    return {
      movingDate: false,
      movingTime: false,
      includingDate: false,
      includingTime: false,
      targetDate: null,
      targetTime: null
    };
  },

  computed: {
    repeats: function repeats() {
      return !this.schedule.isSingleEvent();
    },
    event: function event() {
      return this.calendarEvent.event;
    },
    canRemove: function canRemove() {
      return this.allowRemove;
    },
    canExclude: function canExclude() {
      return this.allowExclude && this.repeats;
    },
    canCancel: function canCancel() {
      return this.allowCancel && !this.calendarEvent.cancelled;
    },
    canUncancel: function canUncancel() {
      return this.allowUncancel && this.calendarEvent.cancelled;
    },
    canMove: function canMove() {
      return this.allowMove;
    },
    canInclude: function canInclude() {
      return this.allowInclude;
    },
    canSetStart: function canSetStart() {
      return this.allowSetStart;
    },
    canSetEnd: function canSetEnd() {
      return this.allowSetEnd;
    },
    moving: function moving() {
      return this.movingDate || this.movingTime;
    },
    including: function including() {
      return this.includingDate || this.includingTime;
    }
  },

  methods: {
    remove: function remove() {
      var _this = this;

      this.$dayspan.getPermission('actionRemove', function () {
        var ev = _this.getEvent('remove');

        _this.$emit('remove', ev);

        if (!ev.handled && ev.calendar) {
          ev.calendar.removeEvent(ev.event);
          ev.handled = true;
        }

        _this.$emit('finish', ev);

        _this.$emit('event-remove', ev.event);
      });
    },
    exclude: function exclude() {
      var _this2 = this;

      this.$dayspan.getPermission('actionExclude', function () {
        var ev = _this2.getEvent('exclude');

        _this2.$emit('exclude', ev);

        if (!ev.handled && ev.calendarEvent) {
          ev.calendarEvent.exclude();
          ev.refresh && ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this2.$emit('finish', ev);

        _this2.$emit('event-update', ev.event);
      });
    },
    cancel: function cancel() {
      var _this3 = this;

      this.$dayspan.getPermission('actionCancel', function () {
        var ev = _this3.getEvent('cancel');

        _this3.$emit('cancel', ev);

        if (!ev.handled && ev.calendarEvent) {
          ev.calendarEvent.cancel(true);
          ev.refresh && ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this3.$emit('finish', ev);

        _this3.$emit('event-update', ev.event);
      });
    },
    uncancel: function uncancel() {
      var _this4 = this;

      this.$dayspan.getPermission('actionUncancel', function () {
        var ev = _this4.getEvent('uncancel');

        _this4.$emit('uncancel', ev);

        if (!ev.handled && ev.calendarEvent) {
          ev.calendarEvent.cancel(false);
          ev.refresh && ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this4.$emit('finish', ev);

        _this4.$emit('event-update', ev.event);
      });
    },
    setStart: function setStart() {
      var _this5 = this;

      this.$dayspan.getPermission('actionSetStart', function () {
        var ev = _this5.getEvent('set-start');

        _this5.$emit('set-start', ev);

        if (!ev.handled && ev.calendarEvent) {
          ev.calendarEvent.schedule.start = ev.calendarEvent.day.start();
          ev.refresh && ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this5.$emit('finish', ev);

        _this5.$emit('event-update', ev.event);
      });
    },
    setEnd: function setEnd() {
      var _this6 = this;

      this.$dayspan.getPermission('actionSetEnd', function () {
        var ev = _this6.getEvent('set-end');

        _this6.$emit('set-end', ev);

        if (!ev.handled && ev.calendarEvent) {
          ev.calendarEvent.schedule.end = ev.calendarEvent.day.end();
          ev.refresh && ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this6.$emit('finish', ev);

        _this6.$emit('event-update', ev.event);
      });
    },
    getTarget: function getTarget() {
      if (!this.targetDate) {
        return null;
      }

      var target = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].parse(this.targetDate);

      if (target && this.targetTime) {
        var time = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Time"].parse(this.targetTime);

        if (time) {
          target = target.withTime(time);
        }
      }

      return target;
    },
    setTarget: function setTarget() {
      this.targetDate = this.calendarEvent.start.format('YYYY-MM-DD');
      this.targetTime = this.calendarEvent.start.format('HH:mm');
    },
    moveStart: function moveStart() {
      this.setTarget();
      this.movingDate = true;
    },
    moveEnd: function moveEnd() {
      var _this7 = this;

      if (this.movingDate) {
        this.movingDate = false;

        if (!this.schedule.isFullDay()) {
          this.movingTime = true;

          return;
        }
      }

      if (this.movingTime) {
        this.movingTime = false;
      }

      var target = this.getTarget();

      if (!target) {
        return;
      }

      this.$dayspan.getPermission('actionMove', function () {
        var ev = _this7.getEvent('move', { target: target });

        _this7.$emit('move', ev);

        if (!ev.handled && ev.calendarEvent && ev.target) {
          ev.calendarEvent.move(ev.target);
          ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this7.$emit('finish', ev);

        _this7.$emit('event-update', ev.event);
      });
    },
    includeStart: function includeStart() {
      this.setTarget();
      this.includingDate = true;
    },
    includeEnd: function includeEnd() {
      var _this8 = this;

      if (this.includingDate) {
        this.includingDate = false;

        if (!this.schedule.isFullDay()) {
          this.includingTime = true;

          return;
        }
      }

      if (this.includingTime) {
        this.includingTime = false;
      }

      var target = this.getTarget();

      if (!target) {
        return;
      }

      this.$dayspan.getPermission('actionInclude', function () {
        var ev = _this8.getEvent('include', { target: target });

        _this8.$emit('include', ev);

        if (!ev.handled && ev.calendarEvent && ev.calendarEvent.schedule && ev.target) {
          ev.calendarEvent.schedule.setExcluded(ev.target, false);
          ev.calendar && ev.calendar.refreshEvents();
          ev.handled = true;
        }

        _this8.$emit('finish', ev);

        _this8.$emit('event-update', ev.event);
      });
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        schedule: this.schedule,
        calendar: this.calendar,
        calendarEvent: this.calendarEvent,
        event: this.event,
        handled: false,
        refresh: true,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleForecast',

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    canExclude: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().canExclude;
      }
    },

    hasDescription: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().hasDescription;
      }
    },

    defaultSize: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().defaultSize;
      }
    },

    sizeMax: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().sizeMax;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      size: vm.defaultSize
    };
  },

  computed: {
    sizeInput: {
      get: function get() {
        return this.size;
      },
      set: function set(value) {
        this.size = Math.max(1, Math.min(Math.floor(value), this.sizeMax));
      }
    },

    aroundDay: function aroundDay() {
      return this.day || this.$dayspan.today;
    },
    forecast: function forecast() {
      return this.schedule.forecast(this.aroundDay, false, this.size).map(function (spanDayId) {
        return spanDayId[1];
      }).list();
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  watch: {
    forecast: {
      handler: 'triggerChange',
      immediate: true
    }
  },

  methods: {
    triggerChange: function triggerChange() {
      this.$emit('change', this.getEvent('change'));
    },
    exclude: function exclude(time) {
      var ev = this.getEvent('exclude', { time: time });

      if (!ev.handled && ev.schedule) {
        ev.schedule.setExcluded(ev.time);
        ev.handled = true;
      }
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        schedule: this.schedule,
        size: this.size,
        forecast: this.forecast,
        day: this.day,
        aroundDay: this.aroundDay,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleFrequencyDay',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__["a" /* default */]],

  props: {
    options: {
      default: function _default() {
        return this.$dsDefaults().options;
      }
    },

    types: {
      default: function _default() {
        return this.$dsDefaults().types;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      chosenType: null,
      property: 'dayOfMonth'
    };
  },

  watch: {
    schedule: {
      immediate: true,
      deep: true,
      handler: 'updateProperty'
    },

    chosenType: 'onTypeChange'
  },

  computed: {
    oneOfs: function oneOfs() {
      return this.getOffsets(this.chosenType.max, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Suffix"].CACHE, this.chosenType.min, this.chosenType.offset);
    },
    offsets: function offsets() {
      return this.getOffsets(this.frequency.every + 1, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Suffix"].CACHE, this.chosenType.min, this.chosenType.offset);
    }
  },

  methods: {
    updateProperty: function updateProperty() {
      this.chosenType = this.findType(this.types);
    },
    onTypeChange: function onTypeChange(newType, oldType) {
      this.property = newType.property;
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleFrequencyDayOfWeek',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__["a" /* default */]],

  props: {
    options: {
      default: function _default() {
        return this.$dsDefaults().options;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    weekdays: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().weekdays;
      }
    }
  },

  data: function data(vm) {
    return {
      property: 'dayOfWeek'
    };
  },

  computed: {
    isSimple: function isSimple() {
      return this.type === 'any' || this.type === 'weekday' || this.type === 'weekend';
    },
    oneOfs: function oneOfs() {
      return this.weekdays.map(function (name, i) {
        return {
          text: name,
          value: i
        };
      });
    },
    offsets: function offsets() {
      return this.getOffsets(this.frequency.every, this.weekdays);
    }
  },

  methods: {
    getCustomFrequencyType: function getCustomFrequencyType(x) {
      if (x && __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArrayEquals(x, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Weekday"].WEEK)) return 'weekday';
      if (x && __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isArrayEquals(x, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Weekday"].ENDS)) return 'weekend';
    },
    setCustomFrequencyType: function setCustomFrequencyType(type) {
      switch (type) {
        case 'weekday':
          this.frequency = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Weekday"].WEEK;
          break;
        case 'weekend':
          this.frequency = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Weekday"].ENDS;
          break;
      }
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleFrequency__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleFrequencyMonth',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__ScheduleFrequency__["a" /* default */]],

  props: {
    options: {
      default: function _default() {
        return this.$dsDefaults().options;
      }
    },

    months: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().months;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      property: 'month'
    };
  },

  computed: {
    oneOfs: function oneOfs() {
      return this.months.map(function (name, i) {
        return {
          text: name,
          value: i
        };
      });
    },
    offsets: function offsets() {
      return this.getOffsets(this.frequency.every, this.months);
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleFrequencyWeek',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__["a" /* default */]],

  props: {
    options: {
      default: function _default() {
        return this.$dsDefaults().options;
      }
    },

    types: {
      default: function _default() {
        return this.$dsDefaults().types;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      chosenType: null,
      property: 'weekspanOfMonth'
    };
  },

  watch: {
    schedule: {
      immediate: true,
      deep: true,
      handler: 'updateProperty'
    },

    chosenType: 'onTypeChange'
  },

  computed: {
    oneOfs: function oneOfs() {
      return this.getOffsets(this.chosenType.max, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Suffix"].CACHE, this.chosenType.min, this.chosenType.offset);
    },
    offsets: function offsets() {
      return this.getOffsets(this.frequency.every + 1, __WEBPACK_IMPORTED_MODULE_0_dayspan__["Suffix"].CACHE);
    }
  },

  methods: {
    updateProperty: function updateProperty() {
      this.chosenType = this.findType(this.types);
    },
    onTypeChange: function onTypeChange(newType, oldType) {
      this.property = newType.property;
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleFrequencyYear',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__ScheduleFrequency__["a" /* default */]],

  props: {
    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    lookback: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().lookback;
      }
    },

    lookahead: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().lookahead;
      }
    },

    options: {
      default: function _default() {
        return this.$dsDefaults().options;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      property: 'year'
    };
  },

  computed: {
    currentYear: function currentYear() {
      return (this.schedule.start || this.day || this.$dayspan.today).year;
    },
    oneOfs: function oneOfs() {
      var currentYear = this.currentYear;
      var min = currentYear - this.lookback;
      var max = currentYear + this.lookahead;
      var oneof = [];
      for (var i = min; i <= max; i++) {
        oneof.push({
          text: i,
          value: i
        });
      }
      return oneof;
    },
    offsets: function offsets() {
      var max = this.frequency.every;
      var currentYear = this.currentYear;
      var offsets = [];

      for (var i = 0; i < max; i++) {
        offsets.push({
          text: currentYear + i,
          value: i
        });
      }
      return offsets;
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleModifier',

  props: {
    modifier: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["ScheduleModifier"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    canRemove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().canRemove;
      }
    },

    description: {
      type: String,
      default: function _default() {
        return this.$dsDefaults().description;
      }
    }
  },

  data: function data(vm) {
    return {};
  },

  computed: {
    identifiers: function identifiers() {
      return this.modifier.identifiers(function (x) {
        return x;
      }).list();
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    remove: function remove(identifier) {
      var ev = this.getEvent('remove', { identifier: identifier });

      if (!ev.handled && ev.modifier) {
        ev.modifier.map[identifier] = false;
        ev.handled = true;
      }

      this.$emit('change', ev);
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        modifier: this.modifier,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleSpan',

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    day: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    }
  },

  data: function data(vm) {
    return {
      startMenu: false,
      endMenu: false
    };
  },

  computed: {
    hasStart: function hasStart() {
      return !!this.schedule.start;
    },
    hasEnd: function hasEnd() {
      return !!this.schedule.end;
    },


    startSpan: function startSpan() {
      var point = this.schedule.start || this.day;

      return point ? __WEBPACK_IMPORTED_MODULE_0_dayspan__["DaySpan"].point(point) : null;
    },

    startText: function startText() {
      return this.schedule.start ? this.schedule.start.format(this.formats.start) : this.labels.startless;
    },
    endSpan: function endSpan() {
      var point = this.schedule.end || this.day;

      return point ? __WEBPACK_IMPORTED_MODULE_0_dayspan__["DaySpan"].point(point) : null;
    },
    endText: function endText() {
      return this.schedule.end ? this.schedule.end.format(this.formats.end) : this.labels.endless;
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    setStart: function setStart(start) {
      var ev = this.getEvent('start', { start: start });

      this.$emit('start', ev);

      if (!ev.handled && ev.schedule) {
        ev.schedule.start = ev.start;
        ev.handled = true;
      }

      this.startMenu = false;

      this.$emit('change', ev);
    },
    setEnd: function setEnd(end) {
      var ev = this.getEvent('end', { end: end });

      this.$emit('end', ev);

      if (!ev.handled && ev.schedule) {
        ev.schedule.end = ev.end;
        ev.handled = true;
      }

      this.endMenu = false;

      this.$emit('change', ev);
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        schedule: this.schedule,
        day: this.day,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleTime',

  props: {
    value: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Time"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: function _default() {
        return this.$dsDefaults().index;
      }
    },

    mutate: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().mutate;
      }
    },

    showAdd: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().showAdd;
      }
    },

    showRemove: {
      type: Boolean,
      default: function _default() {
        return this.$dsDefaults().showRemove;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    colors: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'colors');
      },
      default: function _default() {
        return this.$dsDefaults().colors;
      }
    },

    icons: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'icons');
      },
      default: function _default() {
        return this.$dsDefaults().icons;
      }
    }
  },

  data: function data(vm) {
    return {};
  },

  computed: {
    time: {
      get: function get() {
        return this.value.format('HH:mm');
      },
      set: function set(time) {
        this.setTime(time);
      }
    },

    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    addTime: function addTime() {
      this.$emit('add', this.getEvent('add'));
    },
    removeTime: function removeTime() {
      this.$emit('remove', this.getEvent('remove'));
    },
    setTime: function setTime(time) {
      var parsed = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Time"].parse(time);

      if (parsed) {
        var ev = this.getEvent('change', { next: parsed });

        this.$emit('change', ev);

        if (!ev.handled) {
          if (ev.mutate) {
            ev.time.set(ev.next);

            parsed = ev.next;
          }

          this.$emit('input', parsed);
        }
      }
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        time: this.value,
        index: this.index,
        mutate: this.mutate,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleTimes',

  props: {
    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    },

    defaultTime: {
      type: String,
      default: function _default() {
        return this.$dsDefaults().defaultTime;
      }
    }
  },

  computed: {
    durationOptions: function durationOptions() {
      var singular = this.schedule.duration === 1;

      var duringDay = [{ text: singular ? this.labels.minute : this.labels.minutes, value: 'minutes' }, { text: singular ? this.labels.hour : this.labels.hours, value: 'hours' }];
      var allDay = [{ text: singular ? this.labels.day : this.labels.days, value: 'days' }, { text: singular ? this.labels.week : this.labels.weeks, value: 'weeks' }, { text: singular ? this.labels.month : this.labels.months, value: 'months' }];

      return this.allDay ? allDay : duringDay.concat(allDay);
    },
    hasTimes: function hasTimes() {
      return this.schedule.times.length > 1;
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  data: function data(vm) {
    return {
      allDay: false
    };
  },

  watch: {
    schedule: {
      handler: 'updateAllDay',
      immediate: true
    },
    allDay: 'updateScheduleAllDay'
  },

  methods: {
    updateAllDay: function updateAllDay() {
      this.allDay = this.schedule.isFullDay();
    },
    updateScheduleAllDay: function updateScheduleAllDay(allDay) {
      var _this = this;

      if (this.schedule.isFullDay() !== allDay) {
        this.$dayspan.getPermission('toggleAllDay', function (prompted) {
          _this.schedule.setFullDay(allDay);
          _this.triggerChange();
        }, function () {
          _this.allDay = !allDay;
        });
      }
    },
    changeTime: function changeTime(ev) {
      ev.schedule = this.schedule;
      ev.updated = false;

      this.$emit('update', ev);

      if (!ev.handled && ev.schedule) {
        ev.updated = ev.schedule.moveTime(ev.time, ev.next);
        ev.handled = true;
      }

      this.$emit('change', ev);
    },
    addTime: function addTime(ev) {
      ev.time = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Time"].parse(this.defaultTime);
      ev.schedule = this.schedule;

      if (ev.time) {
        this.$emit('add', ev);

        if (!ev.handled && ev.schedule) {
          ev.schedule.times.push(ev.time);
          ev.handled = true;
        }

        this.$emit('change', ev);
      }
    },
    removeTime: function removeTime(ev) {
      var _this2 = this;

      this.$dayspan.getPermission('removeExistingTime', function () {
        ev.schedule = _this2.schedule;

        _this2.$emit('remove', ev);

        if (!ev.handled && ev.schedule && ev.time) {
          ev.handled = ev.schedule.removeTime(ev.time);
        }

        _this2.$emit('change', ev);
      });
    },
    isLastTime: function isLastTime(index) {
      return index === this.schedule.times.length - 1;
    },
    triggerChange: function triggerChange() {
      this.$emit('change', this.getEvent('change'));
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        schedule: this.schedule,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleType',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    }
  },

  data: function data() {
    return {
      type: ''
    };
  },

  watch: {
    schedule: {
      handler: 'updateType',
      immediate: true
    },

    type: 'applyType'
  },

  computed: {
    hideHint: function hideHint() {
      return this.type !== 'none' && this.type !== 'custom';
    },
    typeHint: function typeHint() {
      if (this.type === 'none') {
        return this.day.format(this.formats.date);
      }

      if (this.type === 'custom') {
        return this.$dayspan.getScheduleDescription(this.schedule);
      }

      return '';
    },
    types: function types() {
      var _this = this;

      if (!this.day) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Patterns"].filter(function (pattern) {
        return pattern.listed;
      }).map(function (pattern) {
        return {
          label: pattern.describe(_this.day),
          value: pattern.name
        };
      });
    },
    customIcon: function customIcon() {
      return this.type === 'custom' ? 'edit' : '';
    },
    isReadOnly: function isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    }
  },

  methods: {
    applyType: function applyType(newType, oldType) {
      if (this.applying) {
        if (oldType === 'custom') {
          this.schedule.end = null;
        }

        if (newType) {
          var pattern = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"].withName(newType);

          if (pattern) {
            pattern.apply(this.schedule, this.day);
          }
        }

        if (newType === 'none') {
          this.schedule.adjustDefinedSpan();
        }
      }

      this.$emit('change', newType);
    },
    custom: function custom() {
      this.$emit('custom', this);
    },
    updateType: function updateType() {
      this.applying = false;
      this.type = this.determineType();
      this.applying = true;
    },
    determineType: function determineType() {
      var pattern = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"].findMatch(this.schedule);

      return pattern ? pattern.name : 'custom';
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleTypeCustom',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"]
    },

    schedule: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]
    }
  },

  data: function data(vm) {
    return {};
  },

  computed: {
    customDescription: function customDescription() {
      return this.$dayspan.getScheduleDescription(this.schedule);
    }
  },

  methods: {}
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsScheduleTypeCustomDialog',

  props: {
    dialogProps: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'dialogProps');
      },
      default: function _default() {
        return this.$dsDefaults().dialogProps;
      }
    },

    labels: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'labels');
      },
      default: function _default() {
        return this.$dsDefaults().labels;
      }
    }
  },

  data: function data(vm) {
    return {
      visible: false,
      original: null,
      copy: null,
      day: null
    };
  },

  computed: {
    hasData: function hasData() {
      return !!this.copy;
    },
    aroundDay: function aroundDay() {
      return this.day || this.$dayspan.today;
    }
  },

  methods: {
    edit: function edit(schedule, day) {
      this.original = schedule;
      this.copy = schedule.clone();
      this.day = day;
      this.visible = true;

      this.$emit('show', this.getEvent('show'));
    },
    create: function create() {
      this.original = null;
      this.copy = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]();
      this.day = null;
      this.visible = true;

      this.$emit('show', this.getEvent('show'));
    },
    save: function save() {
      var ev = this.getEvent('save');

      this.$emit('save', ev);

      if (!ev.handled && ev.target && ev.schedule) {
        ev.target.set(ev.schedule);
        ev.handled = true;
      }

      this.finish(ev);
    },
    hide: function hide() {
      this.finish(this.getEvent('hide'));
    },
    cancel: function cancel() {
      var ev = this.getEvent('cancel');

      this.$emit('cancel', ev);
      this.finish(ev);
    },
    finish: function finish(ev) {
      if (ev.hide && this.visible) {
        this.visible = false;
        this.$emit('hide', ev);
      }
    },
    getEvent: function getEvent(type) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        target: this.original,
        schedule: this.copy,
        day: this.day,
        hide: true,
        handled: false,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsWeekDayHeader',

  props: {
    day: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarDay"]
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    formats: {
      validate: function validate(x) {
        return this.$dsValidate(x, 'formats');
      },
      default: function _default() {
        return this.$dsDefaults().formats;
      }
    }
  },

  computed: {
    classesDay: function classesDay() {
      return {
        'ds-day-today': this.day.currentDay,
        'ds-day-past': this.day.currentOffset < 0,
        'ds-day-future': this.day.currentOffset > 0
      };
    },
    dayOfMonth: function dayOfMonth() {
      return this.day.dayOfMonth;
    },
    weekday: function weekday() {
      return this.day.format(this.formats.weekday);
    },
    hasPlaceholder: function hasPlaceholder() {
      return this.placeholder && this.placeholder.time.matchesDay(this.day) && this.placeholder.fullDay;
    },
    visibleEvents: function visibleEvents() {
      return this.day.events.filter(this.isVisible);
    }
  },

  methods: {
    isVisible: function isVisible(calendarEvent) {
      if (!calendarEvent.fullDay) {
        return false;
      }

      if (this.$dayspan.features.hideOnMove && this.placeholder && this.placeholder.event === calendarEvent.event) {
        return false;
      }

      return true;
    },
    add: function add() {
      this.$emit('add', this.day);
    },
    viewDay: function viewDay(event) {
      this.$emit('view-day', this.day);
    },
    mouseEnterDay: function mouseEnterDay($event) {
      this.$emit('mouse-enter-day', this.day);
    },
    mouseLeaveDay: function mouseLeaveDay($event) {
      this.$emit('mouse-leave-day', this.day);
    },
    mouseMoveDay: function mouseMoveDay($event) {
      this.$emit('mouse-move-day', this.getEvent('mouse-move-day', $event));
    },
    mouseDownDay: function mouseDownDay($event) {
      this.$emit('mouse-down-day', this.getEvent('mouse-down-day', $event));
    },
    mouseUpDay: function mouseUpDay($event) {
      this.$emit('mouse-up-day', this.getEvent('mouse-up-day', $event));
    },
    getEvent: function getEvent(type, $event) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].extend({

        type: type,
        day: this.day,
        calendar: this.calendar,
        left: $event.button === 0 && $event.buttons > 0,
        right: $event.button === 1 && $event.buttons > 0,
        handled: false,
        $event: $event,
        $vm: this,
        $element: this.$el

      }, extra);
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsWeekHeader',

  props: {
    days: {
      required: true,
      type: Array
    },

    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    scrollPush: {
      type: Number,
      default: 0
    }
  },

  computed: {
    style: function style() {
      return {
        marginRight: this.scrollPush + 'px'
      };
    }
  },

  methods: {}
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'dsWeeksView',

  props: {
    calendar: {
      required: true,
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Calendar"]
    },

    placeholder: {
      type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"]
    },

    placeholderForCreate: {
      type: Boolean,
      default: false
    },

    weekdays: {
      type: Array,
      default: function _default() {
        return this.$dsDefaults().weekdays;
      }
    }
  },

  computed: {
    rows: function rows() {
      return Math.floor(this.calendar.days.length / 7);
    }
  },

  methods: {
    daysAtRow: function daysAtRow(row, rowSize) {
      var start = (row - 1) * rowSize;

      return this.calendar.days.slice(start, start + rowSize);
    },
    weekdayClasses: function weekdayClasses(weekday) {
      return {
        'ds-week-header-today': this.$dayspan.today.dayOfWeek === weekday
      };
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var LOCALE_ENTRY = 0;

/* harmony default export */ __webpack_exports__["a"] = ([{ text: LOCALE_ENTRY, value: '#F44336' }, { text: LOCALE_ENTRY, value: '#E91E63' }, { text: LOCALE_ENTRY, value: '#9C27B0' }, { text: LOCALE_ENTRY, value: '#673AB7' }, { text: LOCALE_ENTRY, value: '#3F51B5' }, { text: LOCALE_ENTRY, value: '#2196F3' }, { text: LOCALE_ENTRY, value: '#1976d2' }, { text: LOCALE_ENTRY, value: '#03A9F4' }, { text: LOCALE_ENTRY, value: '#00BCD4' }, { text: LOCALE_ENTRY, value: '#009688' }, { text: LOCALE_ENTRY, value: '#4CAF50' }, { text: LOCALE_ENTRY, value: '#8BC34A' }, { text: LOCALE_ENTRY, value: '#CDDC39' }, { text: LOCALE_ENTRY, value: '#FFEB3B' }, { text: LOCALE_ENTRY, value: '#FFC107' }, { text: LOCALE_ENTRY, value: '#FF9800' }, { text: LOCALE_ENTRY, value: '#FF5722' }, { text: LOCALE_ENTRY, value: '#795548' }, { text: LOCALE_ENTRY, value: '#607D8B' }, { text: LOCALE_ENTRY, value: '#9E9E9E' }, { text: LOCALE_ENTRY, value: '#000000' }]);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);









var LOCALE_ENTRY = 0;

/* harmony default export */ __webpack_exports__["a"] = ({

  data: {
    version: '0.3.0',

    readOnly: false,

    today: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].today(),
    tomorrow: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].tomorrow(),
    now: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].now(),
    timeout: null,
    refreshInterval: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_MINUTE,

    dayPadding: 5,
    dayHeight: 960,
    columnOffset: 10,
    eventHeight: 21,
    hourHeight: 40,

    inactiveBlendTarget: { r: 255, g: 255, b: 255 },
    inactiveBlendAmount: 0.5,

    placeholderBlendAmount: 0.2,
    placeholderBlendTarget: { r: 255, g: 255, b: 255 },

    rounding: {
      move: 1,
      add: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_MINUTE * 15,
      drag: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_MINUTE * 15
    },

    supports: {
      title: true,
      description: true,
      color: true,
      location: true,
      calendar: true,
      busy: true,
      icon: true,
      guests: false
    },

    features: {
      exclude: true,
      include: true,
      cancel: true,
      move: true,
      moveDuplicate: true,
      moveInstance: true,
      moveAll: true,
      drag: true,
      forecast: true,
      addDay: true,
      addTime: true,
      hideOnMove: true
    },

    prompt: {
      actionRemove: true,
      actionExclude: true,
      actionCancel: true,
      actionUncancel: true,
      actionMove: true,
      actionInclude: true,
      actionSetStart: true,
      actionSetEnd: true,
      move: true,
      toggleAllDay: true,
      removeExistingTime: true
    },

    promptOpen: null,

    promptLabels: {
      actionRemove: LOCALE_ENTRY,
      actionExclude: LOCALE_ENTRY,
      actionCancel: LOCALE_ENTRY,
      actionUncancel: LOCALE_ENTRY,
      actionSetStart: LOCALE_ENTRY,
      actionSetEnd: LOCALE_ENTRY,
      actionMove: LOCALE_ENTRY,
      actionInclude: LOCALE_ENTRY,
      move: LOCALE_ENTRY,
      toggleAllDay: LOCALE_ENTRY,
      removeExistingTime: LOCALE_ENTRY
    },

    placeholder: {
      noTitle: LOCALE_ENTRY
    },

    patterns: {
      lastDay: LOCALE_ENTRY,
      lastDayOfMonth: LOCALE_ENTRY,
      lastWeekday: LOCALE_ENTRY
    },

    colors: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */],

    icons: __WEBPACK_IMPORTED_MODULE_3__icons__["a" /* default */],

    defaults: __WEBPACK_IMPORTED_MODULE_1__defaults__["a" /* default */],

    locales: __WEBPACK_IMPORTED_MODULE_4__locales__["a" /* default */],

    currentLocale: __WEBPACK_IMPORTED_MODULE_4__locales__["b" /* defaultLocale */]
  },

  computed: {
    fullscreenPopovers: function fullscreenPopovers() {
      return this.$vuetify.breakpoint.xs;
    },
    fullscreenDialogs: function fullscreenDialogs() {
      return this.$vuetify.breakpoint.xs;
    }
  },

  methods: {
    normalizeLocaleName: function normalizeLocaleName(name) {
      return name.toLowerCase();
    },
    getLocale: function getLocale(name) {
      return this.locales[this.normalizeLocaleName(name)];
    },
    setLocale: function setLocale(name, strict) {
      var locale = this.getLocale(name);

      if (!locale && strict) {
        throw 'No locale exists with the name ' + name;
      } else if (locale) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__functions__["e" /* dsMergeLocale */])(this, locale, name);

        this.currentLocale = name;
      }
    },
    addLocale: function addLocale(name, locale) {
      this.locales[this.normalizeLocaleName(name)] = locale;
    },
    addLocales: function addLocales(names, locale) {
      var _this = this;

      names.forEach(function (n) {
        return _this.addLocale(n, locale);
      });
    },
    updateLocale: function updateLocale(name, update) {
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var locale = this.getLocale(name);

      if (!locale) {
        throw 'No locale exists with the name ' + name;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__functions__["e" /* dsMergeLocale */])(locale, update, '', strict);
    },
    init: function init() {
      this.setLocale(this.currentLocale, true);
      this.startRefreshTimes();
      this.addPatterns();
    },
    setEventDetails: function setEventDetails(details, data, event, calendarEvent) {
      event.data = __WEBPACK_IMPORTED_MODULE_6_vue___default.a.util.extend(data, details);
    },
    copyEventDetails: function copyEventDetails(details) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__functions__["f" /* dsMerge */])({}, details);
    },
    createEventData: function createEventData(details, schedule) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__functions__["f" /* dsMerge */])({}, details);;
    },
    createEvent: function createEvent(details, schedule, forPlaceholder) {
      return __WEBPACK_IMPORTED_MODULE_0_dayspan__["Parse"].event({
        schedule: schedule,
        data: this.createEventData(details, schedule)
      });
    },
    addPatterns: function addPatterns() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_dayspan__["Patterns"].unshift(__WEBPACK_IMPORTED_MODULE_0_dayspan__["PatternMap"].lastDay = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"]('lastDay', false, function (day) {
        return _this2.patterns.lastDay(day);
      }, {
        lastDayOfMonth: [1]
      }));

      __WEBPACK_IMPORTED_MODULE_0_dayspan__["Patterns"].unshift(__WEBPACK_IMPORTED_MODULE_0_dayspan__["PatternMap"].lastDayOfMonth = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"]('lastDayOfMonth', false, function (day) {
        return _this2.patterns.lastDayOfMonth(day);
      }, {
        month: 1,
        lastDayOfMonth: [1]
      }));

      __WEBPACK_IMPORTED_MODULE_0_dayspan__["Patterns"].unshift(__WEBPACK_IMPORTED_MODULE_0_dayspan__["PatternMap"].lastWeekday = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"]('lastWeekday', false, function (day) {
        return _this2.patterns.lastWeekday(day);
      }, {
        lastWeekspanOfMonth: [0],
        dayOfWeek: 1,
        month: 1
      }));
    },
    getDefaultEventDetails: function getDefaultEventDetails() {
      return {
        title: '',
        description: '',
        location: '',
        color: this.getDefaultEventColor(),
        forecolor: '#ffffff',
        calendar: '',
        busy: true,
        icon: ''
      };
    },
    getDefaultEventColor: function getDefaultEventColor() {
      return this.colors[Math.floor(this.colors.length * Math.random())].value;
    },
    isValidEvent: function isValidEvent(details, schedule, calendarEvent) {
      return !!details.title;
    },
    requiresPermission: function requiresPermission(type) {
      return !!(this.prompt[type] && this.promptLabels[type] && this.promptOpen);
    },
    getPermission: function getPermission(type, granted, denied) {
      var prompt = this.prompt[type];
      var promptLabel = this.promptLabels[type];

      if (prompt && promptLabel && this.promptOpen) {
        this.promptOpen(promptLabel, function (yes) {
          if (yes) {
            granted(true);
          } else if (denied) {
            denied();
          }
        });
      } else {
        granted(false);
      }
    },
    getPrefix: function getPrefix(calendarEvent, sameDay) {
      return sameDay.length === 1 ? sameDay[0].start.format('ha') : '(' + sameDay.length + ')';
    },
    getScheduleDescription: function getScheduleDescription(schedule) {
      return schedule.describe('event', false, false, false, false);
    },
    getEventOccurrence: function getEventOccurrence(schedule, start, labels, formats) {
      var duration = this.getEventDuration(schedule, labels);

      if (schedule.isSingleEvent()) {
        if (schedule.isFullDay()) {
          return duration;
        } else {
          return start.asTime().format(formats.time);
        }
      }

      var pattern = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Pattern"].findMatch(schedule, false);

      if (pattern && pattern.name !== 'custom') {
        var description = '';

        if (pattern.name !== 'none') {
          description = pattern.describe(start);
        }

        if (!schedule.isFullDay()) {
          if (description) {
            description += ' at ';
          }

          description += schedule.describeArray(schedule.times, function (x) {
            return x.format(formats.time);
          });
        }

        description += ' (' + duration + ')';

        return description;
      }

      var described = schedule.describe('event', false);

      return described.substring(20) + ' (' + duration + ')';
    },
    getEventAgendaWhen: function getEventAgendaWhen(calendarEvent, labels, formats) {
      var when = '';
      var schedule = calendarEvent.schedule;

      if (calendarEvent.fullDay) {
        when += labels.allDay;
      } else {
        when += schedule.describeArray(schedule.times, function (x) {
          return x.format(formats.time);
        });
      }

      if (schedule.duration !== 1 && this.$vuetify.breakpoint.smAndUp) {
        when += ' (' + this.getEventDuration(schedule, labels) + ')';
      }

      return when;
    },
    getEventDuration: function getEventDuration(schedule, labels) {
      var units = labels[schedule.durationUnit];
      var length = schedule.duration;
      var chosenUnit = length === 1 ? units[0] : units[1];
      var duration = length + ' ' + chosenUnit;

      return duration;
    },
    getPlaceholderEventDetails: function getPlaceholderEventDetails() {
      var details = this.getDefaultEventDetails();

      details.title = this.placeholder.noTitle;

      return details;
    },
    getPlaceholderEventForAdd: function getPlaceholderEventForAdd(time) {
      var details = this.getPlaceholderEventDetails();
      var schedule = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["Schedule"]({});
      var id = time.timeIdentifier;
      var event = this.createEvent(details, schedule, true);
      var span = __WEBPACK_IMPORTED_MODULE_0_dayspan__["DaySpan"].point(time);
      var day = time.start();

      return new __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"](id, event, span, day);
    },
    getPlaceholderEventForMove: function getPlaceholderEventForMove(original) {
      var placeholder = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["CalendarEvent"](original.id, original.event, original.time, original.day);

      placeholder.time = new __WEBPACK_IMPORTED_MODULE_0_dayspan__["DaySpan"](original.start, original.end);
      placeholder.col = 0;
      placeholder.row = 0;

      return placeholder;
    },
    getStyleFull: function getStyleFull(details, calendarEvent, index) {
      var past = calendarEvent.time.start.isBefore(this.today);
      var cancelled = calendarEvent.cancelled;

      var color = this.getStyleColor(details, calendarEvent);
      var stateColor = this.getStyleColor(details, calendarEvent, past, cancelled);

      return {
        top: (calendarEvent.row - (index || 0)) * this.eventHeight + 'px',
        backgroundColor: stateColor,
        color: details.forecolor,
        left: calendarEvent.starting ? '0px' : '-5px',
        right: calendarEvent.ending ? '0px' : '-6px',
        textDecoration: cancelled ? 'line-through' : 'inherit',
        textDecorationColor: cancelled ? color : 'inherit'
      };
    },
    getStyleTimed: function getStyleTimed(details, calendarEvent) {
      var past = calendarEvent.time.end.isBefore(this.now);
      var cancelled = calendarEvent.cancelled;
      var bounds = calendarEvent.getTimeBounds(this.dayHeight, 1, this.columnOffset);

      var color = this.getStyleColor(details, calendarEvent);
      var stateColor = this.getStyleColor(details, calendarEvent, past, cancelled);

      return {
        top: bounds.top + 'px',
        height: bounds.height + 'px',
        left: bounds.left + '%',
        width: 100 - bounds.left + '%',
        backgroundColor: stateColor,
        marginLeft: calendarEvent.starting ? 0 : '-5px',
        marginRight: calendarEvent.ending ? 0 : '-5px',
        textDecoration: cancelled ? 'line-through' : 'inherit',
        textDecorationColor: cancelled ? stateColor : 'inherit'
      };
    },
    getStylePopover: function getStylePopover(details, calendarEvent) {},
    getStyleNowBorder: function getStyleNowBorder() {
      return 'black solid 3px';
    },
    getStyleNow: function getStyleNow() {
      var now = this.now.asTime().toMilliseconds();
      var delta = now / __WEBPACK_IMPORTED_MODULE_0_dayspan__["Constants"].MILLIS_IN_DAY;
      var top = delta * this.dayHeight;

      return {
        position: 'absolute',
        left: '0px',
        right: '-1px',
        top: top - 1 + 'px',
        borderTop: this.getStyleNowBorder()
      };
    },
    getStyleColor: function getStyleColor(details, calendarEvent, past, cancelled) {
      var color = details.color;

      if (past || cancelled) {
        color = this.blend(color, this.inactiveBlendAmount, this.inactiveBlendTarget);
      }

      return color;
    },
    getStylePlaceholderTimed: function getStylePlaceholderTimed(details, placeholder, forDay) {
      var bounds = placeholder.time.getBounds(forDay, this.dayHeight);
      var stateColor = this.getStyleColor(details, placeholder);

      return {
        top: bounds.top + 'px',
        height: bounds.height + 'px',
        left: '0px',
        right: '0px',
        marginRight: '-1px',
        backgroundColor: this.blend(stateColor, this.placeholderBlendAmount, this.placeholderBlendTarget)
      };
    },
    getStylePlaceholderFull: function getStylePlaceholderFull(details, calendarEvent, index, forDay) {
      var color = this.getStyleColor(details, calendarEvent);
      var stateColor = this.getStyleColor(details, calendarEvent);
      var starting = calendarEvent.time.start.sameDay(forDay);
      var ending = calendarEvent.time.end.sameDay(forDay);

      return {
        top: (calendarEvent.row - (index || 0)) * this.eventHeight + 'px',
        color: details.forecolor,
        left: starting ? '0px' : '-5px',
        right: ending ? '0px' : '-6px',
        backgroundColor: this.blend(stateColor, this.placeholderBlendAmount, this.placeholderBlendTarget)
      };
    },
    parseColor: function parseColor(color) {
      if (__WEBPACK_IMPORTED_MODULE_0_dayspan__["Functions"].isObject(color)) {
        return color;
      }

      var match = /#(\w\w)(\w\w)(\w\w)/.exec(color);

      if (!match) {
        throw 'Colors must be in the format of #rrggbb';
      }

      return {
        r: parseInt(match[1], 16),
        g: parseInt(match[2], 16),
        b: parseInt(match[3], 16)
      };
    },
    clampComponent: function clampComponent(c) {
      return Math.max(0, Math.min(255, Math.floor(c)));
    },
    clampColor: function clampColor(color, out) {
      var target = out || color;
      target.r = this.clampComponent(color.r);
      target.g = this.clampComponent(color.g);
      target.b = this.clampComponent(color.b);
      return target;
    },
    formatComponent: function formatComponent(c) {
      var x = c.toString(16);
      return x.length === 1 ? '0' + x : x;
    },
    formatColor: function formatColor(color) {
      return '#' + this.formatComponent(color.r) + this.formatComponent(color.g) + this.formatComponent(color.b);
    },
    blend: function blend(from, delta, to) {
      var parsedFrom = this.parseColor(from);
      var parsedTo = this.parseColor(to);

      var blended = {
        r: parsedTo.r + (parsedFrom.r - parsedTo.r) * delta,
        g: parsedTo.g + (parsedFrom.g - parsedTo.g) * delta,
        b: parsedTo.b + (parsedFrom.b - parsedTo.b) * delta
      };

      this.clampColor(blended);

      return this.formatColor(blended);
    },
    roundTime: function roundTime(day, millis, up) {
      var time = day.time;
      var over = time % millis;
      var relative = -over;

      if (up && relative !== 0) {
        relative += millis;
      }

      return day.relative(relative);
    },
    startRefreshTimes: function startRefreshTimes() {
      var $dayspan = this;

      this.timeout = setTimeout(function () {
        $dayspan.refreshTimes();
        $dayspan.startRefreshTimes();
      }, this.refreshInterval);
    },
    stopRefreshTimes: function stopRefreshTimes() {
      clearTimeout(this.timeout);

      this.timeout = null;
    },
    refreshTimes: function refreshTimes() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var today = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].today();

      if (!today.sameDay(this.today) || force) {
        this.today = today;
        this.tomorrow = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].tomorrow();
      }

      this.now = __WEBPACK_IMPORTED_MODULE_0_dayspan__["Day"].now();
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayspan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayspan__);



var LOCALE_ENTRY = 0;

/* harmony default export */ __webpack_exports__["a"] = ({

  dsCalendar: {
    handleAdd: true,
    handleMove: true
  },

  dsDay: {
    formats: {
      month: LOCALE_ENTRY
    }
  },

  dsCalendarApp: {
    allowsAddToday: true,
    types: [{ id: 'D', label: LOCALE_ENTRY, shortcut: 'D', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].DAY, size: 1, focus: 0.4999, repeat: true, listTimes: true, updateRows: true, schedule: false }, { id: 'W', label: LOCALE_ENTRY, shortcut: 'W', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].WEEK, size: 1, focus: 0.4999, repeat: true, listTimes: true, updateRows: true, schedule: false }, { id: 'M', label: LOCALE_ENTRY, shortcut: 'M', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].MONTH, size: 1, focus: 0.4999, repeat: true, listTimes: false, updateRows: true, schedule: false }, { id: 'Y', label: LOCALE_ENTRY, shortcut: 'Y', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].YEAR, size: 1, focus: 0.4999, repeat: true, listTimes: false, updateRows: true, schedule: false }, { id: 'S', label: LOCALE_ENTRY, shortcut: 'S', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].DAY, size: 92, focus: 0.0000, repeat: false, listTimes: false, updateRows: false, schedule: true }, { id: 'X', label: LOCALE_ENTRY, shortcut: 'X', type: __WEBPACK_IMPORTED_MODULE_0_dayspan__["Units"].DAY, size: 4, focus: 0.4999, repeat: true, listTimes: true, updateRows: true, schedule: false }],
    formats: {
      today: LOCALE_ENTRY,
      xs: LOCALE_ENTRY
    },
    labels: {
      next: LOCALE_ENTRY,
      prev: LOCALE_ENTRY,
      moveCancel: LOCALE_ENTRY,
      moveSingleEvent: LOCALE_ENTRY,
      moveOccurrence: LOCALE_ENTRY,
      moveAll: LOCALE_ENTRY,
      moveDuplicate: LOCALE_ENTRY,
      promptConfirm: LOCALE_ENTRY,
      promptCancel: LOCALE_ENTRY,
      today: LOCALE_ENTRY,
      todayIcon: 'today'
    },
    styles: {
      toolbar: {
        small: { width: 'auto' },
        large: { width: '300px' }
      }
    },
    optionsDialog: {
      maxWidth: '300px',
      persistent: true
    },
    promptDialog: {
      maxWidth: '300px',
      persistent: true
    }
  },

  dsAgenda: {},

  dsAgendaDay: {},

  dsAgendaEvent: {
    popoverProps: {
      closeOnContentClick: false,
      offsetOverflow: true,
      offsetY: true,
      maxWidth: 500
    },
    formats: {
      firstLine: LOCALE_ENTRY,
      secondLine: LOCALE_ENTRY,
      start: LOCALE_ENTRY,
      time: LOCALE_ENTRY
    },
    labels: {
      allDay: LOCALE_ENTRY,
      options: LOCALE_ENTRY,
      close: LOCALE_ENTRY,
      day: [LOCALE_ENTRY, LOCALE_ENTRY],
      days: [LOCALE_ENTRY, LOCALE_ENTRY],
      minute: [LOCALE_ENTRY, LOCALE_ENTRY],
      minutes: [LOCALE_ENTRY, LOCALE_ENTRY],
      hour: [LOCALE_ENTRY, LOCALE_ENTRY],
      hours: [LOCALE_ENTRY, LOCALE_ENTRY],
      week: [LOCALE_ENTRY, LOCALE_ENTRY],
      weeks: [LOCALE_ENTRY, LOCALE_ENTRY],
      second: [LOCALE_ENTRY, LOCALE_ENTRY],
      seconds: [LOCALE_ENTRY, LOCALE_ENTRY],
      busy: LOCALE_ENTRY,
      free: LOCALE_ENTRY
    }
  },

  dsCalendarEvent: {
    index: 0,
    popoverProps: {
      nudgeWidth: 200,
      closeOnContentClick: false,
      offsetOverflow: true,
      offsetX: true,
      maxWidth: 500
    }
  },

  dsCalendarEventChip: {
    canExclude: true,
    colors: {
      sameForeground: 'white',
      sameBackground: 'primary'
    },
    formats: {
      fullDay: LOCALE_ENTRY,
      timed: LOCALE_ENTRY
    }
  },

  dsCalendarEventPopover: {
    allowEditOnReadOnly: true,
    formats: {
      start: LOCALE_ENTRY,
      time: LOCALE_ENTRY
    },
    labels: {
      allDay: LOCALE_ENTRY,
      options: LOCALE_ENTRY,
      close: LOCALE_ENTRY,
      day: [LOCALE_ENTRY, LOCALE_ENTRY],
      days: [LOCALE_ENTRY, LOCALE_ENTRY],
      minute: [LOCALE_ENTRY, LOCALE_ENTRY],
      minutes: [LOCALE_ENTRY, LOCALE_ENTRY],
      hour: [LOCALE_ENTRY, LOCALE_ENTRY],
      hours: [LOCALE_ENTRY, LOCALE_ENTRY],
      week: [LOCALE_ENTRY, LOCALE_ENTRY],
      weeks: [LOCALE_ENTRY, LOCALE_ENTRY],
      second: [LOCALE_ENTRY, LOCALE_ENTRY],
      seconds: [LOCALE_ENTRY, LOCALE_ENTRY],
      busy: LOCALE_ENTRY,
      free: LOCALE_ENTRY
    }
  },

  dsCalendarEventCreatePopover: {
    prompts: {
      description: true,
      color: true,
      location: true,
      calendar: true,
      busy: true,
      icon: true,
      guests: false
    },
    formats: {
      start: LOCALE_ENTRY,
      time: LOCALE_ENTRY
    },
    icons: {
      save: 'save',
      close: 'close',
      edit: 'edit'
    },
    labels: {
      title: LOCALE_ENTRY,
      allDay: LOCALE_ENTRY,
      close: LOCALE_ENTRY,
      save: LOCALE_ENTRY,
      day: [LOCALE_ENTRY, LOCALE_ENTRY],
      days: [LOCALE_ENTRY, LOCALE_ENTRY],
      minute: [LOCALE_ENTRY, LOCALE_ENTRY],
      minutes: [LOCALE_ENTRY, LOCALE_ENTRY],
      hour: [LOCALE_ENTRY, LOCALE_ENTRY],
      hours: [LOCALE_ENTRY, LOCALE_ENTRY],
      week: [LOCALE_ENTRY, LOCALE_ENTRY],
      weeks: [LOCALE_ENTRY, LOCALE_ENTRY],
      second: [LOCALE_ENTRY, LOCALE_ENTRY],
      seconds: [LOCALE_ENTRY, LOCALE_ENTRY],
      busy: LOCALE_ENTRY,
      free: LOCALE_ENTRY,
      location: LOCALE_ENTRY,
      description: LOCALE_ENTRY,
      calendar: LOCALE_ENTRY
    },
    busyOptions: [{ value: true, text: LOCALE_ENTRY }, { value: false, text: LOCALE_ENTRY }]
  },

  dsCalendarEventPlaceholder: {
    popoverProps: {
      nudgeWidth: 200,
      closeOnContentClick: false,
      closeOnClick: true,
      offsetOverflow: true,
      offsetX: true,
      maxWidth: 500
    }
  },

  dsCalendarEventTimePlaceholder: {
    popoverProps: {
      nudgeWidth: 200,
      closeOnContentClick: false,
      closeOnClick: true,
      offsetOverflow: true,
      offsetX: true,
      maxWidth: 500
    }
  },

  dsCalendarEventTime: {
    placeholderStyle: false,
    disabled: false,
    popoverProps: {
      nudgeWidth: 200,
      closeOnContentClick: false,
      offsetOverflow: true,
      offsetX: true,
      maxWidth: 500
    }
  },

  dsIdentifierChip: {
    description: '',
    short: true,
    canRemove: true
  },

  dsSchedule: {
    allowsRange: true,
    labels: {
      editCustom: LOCALE_ENTRY
    }
  },

  dsEvent: {
    hasTitle: true,
    hasCancel: true,
    hasSave: true,
    canSave: true,
    hasTabs: true,
    hasDetails: true,
    hasForecast: true,
    hasExclusions: true,
    hasInclusions: true,
    hasCancelled: true,
    labels: {
      moreActions: LOCALE_ENTRY,
      cancel: LOCALE_ENTRY,
      save: LOCALE_ENTRY,
      title: LOCALE_ENTRY,
      exclusions: LOCALE_ENTRY,
      inclusions: LOCALE_ENTRY,
      cancelled: LOCALE_ENTRY,
      edit: LOCALE_ENTRY,
      add: LOCALE_ENTRY,
      location: LOCALE_ENTRY,
      description: LOCALE_ENTRY,
      calendar: LOCALE_ENTRY,
      tabs: {
        details: LOCALE_ENTRY,
        forecast: LOCALE_ENTRY,
        removed: LOCALE_ENTRY,
        added: LOCALE_ENTRY,
        cancelled: LOCALE_ENTRY
      }
    },
    busyOptions: [{ value: true, text: LOCALE_ENTRY }, { value: false, text: LOCALE_ENTRY }]
  },

  dsScheduleActions: {
    allowRemove: true,
    allowExclude: true,
    allowCancel: true,
    allowUncancel: true,
    allowMove: true,
    allowInclude: true,
    allowSetStart: true,
    allowSetEnd: true,
    labels: {
      remove: LOCALE_ENTRY,
      exclude: LOCALE_ENTRY,
      cancel: LOCALE_ENTRY,
      uncancel: LOCALE_ENTRY,
      move: LOCALE_ENTRY,
      include: LOCALE_ENTRY,
      setStart: LOCALE_ENTRY,
      setEnd: LOCALE_ENTRY
    }
  },

  dsEventDialog: {
    dialogProps: {
      persistent: true,
      lazy: true,
      maxWidth: '800px'
    }
  },

  dsScheduleForecast: {
    canExclude: true,
    hasDescription: true,
    defaultSize: 5,
    sizeMax: 100,
    labels: {
      prefix: LOCALE_ENTRY,
      suffix: LOCALE_ENTRY
    }
  },

  dsScheduleFrequencyDay: {
    labels: {
      type: LOCALE_ENTRY
    },
    options: [{ text: LOCALE_ENTRY, value: 'any' }, { text: LOCALE_ENTRY, value: 'oneof' }, { text: LOCALE_ENTRY, value: 'every' }],
    types: [{ text: LOCALE_ENTRY, property: 'dayOfMonth', max: 32, min: 1 }, { text: LOCALE_ENTRY, property: 'lastDayOfMonth', max: 32, min: 1 }, { text: LOCALE_ENTRY, property: 'dayOfYear', max: 367, min: 1, offset: -1 }]
  },

  dsScheduleFrequencyDayOfWeek: {
    weekdays: [LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY],
    labels: {
      type: LOCALE_ENTRY
    },
    options: [{ text: LOCALE_ENTRY, value: 'any' }, { text: LOCALE_ENTRY, value: 'oneof' }, { text: LOCALE_ENTRY, value: 'every' }, { text: LOCALE_ENTRY, value: 'weekend' }, { text: LOCALE_ENTRY, value: 'weekday' }]
  },

  dsScheduleFrequencyMonth: {
    months: [LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY],
    labels: {
      type: LOCALE_ENTRY
    },
    options: [{ text: LOCALE_ENTRY, value: 'any' }, { text: LOCALE_ENTRY, value: 'oneof' }, { text: LOCALE_ENTRY, value: 'every' }]
  },

  dsScheduleFrequencyWeek: {
    labels: {
      type: LOCALE_ENTRY
    },
    options: [{ text: LOCALE_ENTRY, value: 'any' }, { text: LOCALE_ENTRY, value: 'oneof' }, { text: LOCALE_ENTRY, value: 'every' }],
    types: [{ text: LOCALE_ENTRY, property: 'weekOfMonth', max: 6 }, { text: LOCALE_ENTRY, property: 'weekspanOfMonth', max: 7, min: 1, offset: -1 }, { text: LOCALE_ENTRY, property: 'fullWeekOfMonth', max: 6 }, { text: LOCALE_ENTRY, property: 'lastWeekspanOfMonth', max: 7, min: 1, offset: -1 }, { text: LOCALE_ENTRY, property: 'lastFullWeekOfMonth', max: 6 }, { text: LOCALE_ENTRY, property: 'weekOfYear', max: 54 }, { text: LOCALE_ENTRY, property: 'weekspanOfYear', max: 53, min: 1, offset: -1 }, { text: LOCALE_ENTRY, property: 'fullWeekOfYear', max: 54 }, { text: LOCALE_ENTRY, property: 'lastWeekspanOfYear', max: 53, min: 1, offset: -1 }, { text: LOCALE_ENTRY, property: 'lastFullWeekOfYear', max: 54 }]
  },

  dsScheduleFrequencyYear: {
    lookback: 5,
    lookahead: 20,
    labels: {
      type: LOCALE_ENTRY
    },
    options: [{ text: LOCALE_ENTRY, value: 'any' }, { text: LOCALE_ENTRY, value: 'oneof' }, { text: LOCALE_ENTRY, value: 'every' }]
  },

  dsScheduleModifier: {
    canRemove: true,
    description: ''
  },

  dsScheduleSpan: {
    labels: {
      startless: LOCALE_ENTRY,
      endless: LOCALE_ENTRY
    },
    formats: {
      start: LOCALE_ENTRY,
      end: LOCALE_ENTRY
    }
  },

  dsScheduleTime: {
    index: -1,
    mutate: true,
    showAdd: false,
    showRemove: false,
    labels: {
      remove: LOCALE_ENTRY,
      add: LOCALE_ENTRY
    },
    colors: {
      add: 'secondary',
      remove: 'secondary'
    },
    icons: {
      add: 'add',
      remove: 'remove'
    }
  },

  dsScheduleTimes: {
    defaultTime: '08:00',
    labels: {
      all: LOCALE_ENTRY,
      minute: LOCALE_ENTRY,
      minutes: LOCALE_ENTRY,
      hour: LOCALE_ENTRY,
      hours: LOCALE_ENTRY,
      day: LOCALE_ENTRY,
      days: LOCALE_ENTRY,
      week: LOCALE_ENTRY,
      weeks: LOCALE_ENTRY,
      month: LOCALE_ENTRY,
      months: LOCALE_ENTRY,
      second: LOCALE_ENTRY,
      seconds: LOCALE_ENTRY
    }
  },

  dsScheduleType: {
    formats: {
      date: LOCALE_ENTRY
    }
  },

  dsScheduleTypeCustomDialog: {
    dialogProps: {
      maxWidth: '600px',
      persistent: true,
      lazy: true
    },
    labels: {
      save: LOCALE_ENTRY,
      cancel: LOCALE_ENTRY
    }
  },

  dsDayPicker: {
    weekdays: [LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY],
    labels: {
      prevMonth: LOCALE_ENTRY,
      nextMonth: LOCALE_ENTRY
    }
  },

  dsWeekDayHeader: {
    formats: {
      weekday: LOCALE_ENTRY
    }
  },

  dsWeeksView: {
    weekdays: [LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY]
  },

  dsDaysView: {
    scrollToFirst: true,
    scrollBuffer: 60,
    hours: [LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY, LOCALE_ENTRY]
  },

  dsGestures: {
    minDistance: 50,
    maxDistance: 200,
    maxWander: 0.1
  }

});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var LOCALE_ENTRY = 0;

/* harmony default export */ __webpack_exports__["a"] = ([{ text: LOCALE_ENTRY, value: 'alarm' }, { text: LOCALE_ENTRY, value: 'star' }, { text: LOCALE_ENTRY, value: 'favorite' }, { text: LOCALE_ENTRY, value: 'flash_on' }, { text: LOCALE_ENTRY, value: 'assignment' }, { text: LOCALE_ENTRY, value: 'warning' }, { text: LOCALE_ENTRY, value: 'attach_money' }, { text: LOCALE_ENTRY, value: 'payment' }, { text: LOCALE_ENTRY, value: 'home' }, { text: LOCALE_ENTRY, value: 'play_circle_outline' }, { text: LOCALE_ENTRY, value: 'email' }, { text: LOCALE_ENTRY, value: 'phone' }, { text: LOCALE_ENTRY, value: 'insert_chart' }, { text: LOCALE_ENTRY, value: 'directions_bike' }, { text: LOCALE_ENTRY, value: 'card_travel' }]);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_lib_scss__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_lib_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_lib_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(5);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsGestures", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsGestures"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsDay", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsDay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsDayRow", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsDayRow"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsDaysView", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsDaysView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsDayTimes", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsDayTimes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsDayPicker", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsDayPicker"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsAgenda", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsAgenda"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsAgendaDay", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsAgendaDay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsAgendaEvent", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsAgendaEvent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendar", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendar"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarApp", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarApp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEvent", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEvent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventTime", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventTime"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventChip", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventChip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventPopover", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventPopover"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventPlaceholder", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventPlaceholder"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventCreatePopover", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventCreatePopover"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsCalendarEventTimePlaceholder", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsCalendarEventTimePlaceholder"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsEvent", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsEvent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsEventDialog", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsEventDialog"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsSchedule", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsSchedule"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleSpan", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleSpan"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleType", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleType"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTime", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleTime"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTimes", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleTimes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleActions", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleActions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleForecast", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleForecast"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleModifier", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleModifier"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTypeCustom", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleTypeCustom"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleTypeCustomDialog", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleTypeCustomDialog"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequency", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequency"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyDay", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequencyDay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyWeek", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequencyWeek"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyYear", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequencyYear"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyMonth", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequencyMonth"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsScheduleFrequencyDayOfWeek", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsScheduleFrequencyDayOfWeek"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsWeeksView", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsWeeksView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsWeekHeader", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsWeekHeader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsWeekDayHeader", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsWeekDayHeader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DsIdentifierChip", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["DsIdentifierChip"]; });







/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1__plugin__["a" /* default */]);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  promptLabels: {
    actionRemove: 'Are you sure you want to remove this event?',
    actionExclude: 'Are you sure you want to remove this event occurrence?',
    actionCancel: 'Are you sure you want to cancel this event?',
    actionUncancel: 'Are you sure you want to uncancel this event?',
    actionSetStart: 'Are you sure you want to set this occurrence as the first?',
    actionSetEnd: 'Are you sure you want to set this occurrence as the last?',
    actionMove: 'Are you sure you want to move this event?',
    actionInclude: 'Are you sure you want to add an event occurrence?',
    move: 'Are you sure you want to move this event?',
    toggleAllDay: 'Are you sure you want to change whether this event occurs all day?',
    removeExistingTime: 'Are you sure you want to remove all event occurrences at this time?'
  },
  placeholder: {
    noTitle: '(no title)'
  },
  patterns: {
    lastDay: function lastDay(day) {
      return 'Last day of the month';
    },
    lastDayOfMonth: function lastDayOfMonth(day) {
      return 'Last day of ' + day.format('MMMM');
    },
    lastWeekday: function lastWeekday(day) {
      return 'Last ' + day.format('dddd') + ' in ' + day.format('MMMM');
    }
  },
  colors: [{ text: 'Red' }, { text: 'Pink' }, { text: 'Purple' }, { text: 'Deep Purple' }, { text: 'Indigo' }, { text: 'Blue' }, { text: 'Glue' }, { text: 'Light Blue' }, { text: 'Cyan' }, { text: 'Teal' }, { text: 'Green' }, { text: 'Light Green' }, { text: 'Lime' }, { text: 'Yellow' }, { text: 'Amber' }, { text: 'Orange' }, { text: 'Deep Orange' }, { text: 'Brown' }, { text: 'Blue Gray' }, { text: 'Gray' }, { text: 'Black' }],
  icons: [{ text: 'Alarm' }, { text: 'Star' }, { text: 'Love' }, { text: 'Action' }, { text: 'Assignment' }, { text: 'Warning' }, { text: 'Money' }, { text: 'Charge' }, { text: 'Home' }, { text: 'Play' }, { text: 'Email' }, { text: 'Phone' }, { text: 'Chart' }, { text: 'Biking' }, { text: 'Travel' }],
  defaults: {
    dsDay: {
      formats: {
        month: 'MMM'
      }
    },
    dsCalendarApp: {
      types: [{ label: 'Day' }, { label: 'Week' }, { label: 'Month' }, { label: 'Year' }, { label: 'Schedule' }, { label: '4 days' }],
      formats: {
        today: 'dddd, MMMM D',
        xs: 'MMM'
      },
      labels: {
        next: function next(type) {
          return type ? 'Next ' + type.label.toLowerCase() : 'Next';
        },
        prev: function prev(type) {
          return type ? 'Previous ' + type.label.toLowerCase() : 'Previous';
        },
        moveCancel: 'Cancel move',
        moveSingleEvent: 'Move event',
        moveOccurrence: 'Move just this event occurrence',
        moveAll: 'Move all event occurrences',
        moveDuplicate: 'Add event occurrence',
        promptConfirm: 'Yes',
        promptCancel: 'No',
        today: 'TODAY'
      }
    },
    dsAgendaEvent: {
      formats: {
        firstLine: 'ddd',
        secondLine: 'MMM Do',
        start: 'dddd, MMMM D',
        time: 'h:mm a'
      },
      labels: {
        allDay: 'All day',
        options: 'Options',
        close: 'Close',
        day: ['day', 'days'],
        days: ['day', 'days'],
        minute: ['minute', 'minutes'],
        minutes: ['minute', 'minutes'],
        hour: ['hour', 'hours'],
        hours: ['hour', 'hours'],
        week: ['week', 'weeks'],
        weeks: ['week', 'weeks'],
        second: ['second', 'seconds'],
        seconds: ['second', 'seconds'],
        busy: 'Busy',
        free: 'Free'
      }
    },
    dsCalendarEventChip: {
      formats: {
        fullDay: 'ddd MMM Do YYYY',
        timed: 'ddd MMM Do YYYY'
      }
    },
    dsCalendarEventPopover: {
      formats: {
        start: 'dddd, MMMM D',
        time: 'h:mm a'
      },
      labels: {
        allDay: 'All day',
        options: 'Options',
        close: 'Close',
        day: ['day', 'days'],
        days: ['day', 'days'],
        minute: ['minute', 'minutes'],
        minutes: ['minute', 'minutes'],
        hour: ['hour', 'hours'],
        hours: ['hour', 'hours'],
        week: ['week', 'weeks'],
        weeks: ['week', 'weeks'],
        second: ['second', 'seconds'],
        seconds: ['second', 'seconds'],
        busy: 'Busy',
        free: 'Free'
      }
    },
    dsCalendarEventCreatePopover: {
      formats: {
        start: 'dddd, MMMM D',
        time: 'h:mm a'
      },
      labels: {
        title: 'Add title',
        allDay: 'All day',
        close: 'Close',
        save: 'Save',
        day: ['day', 'days'],
        days: ['day', 'days'],
        minute: ['minute', 'minutes'],
        minutes: ['minute', 'minutes'],
        hour: ['hour', 'hours'],
        hours: ['hour', 'hours'],
        week: ['week', 'weeks'],
        weeks: ['week', 'weeks'],
        second: ['second', 'seconds'],
        seconds: ['second', 'seconds'],
        busy: 'Busy',
        free: 'Free',
        location: 'Add location',
        description: 'Add description',
        calendar: 'Calendar'
      },
      busyOptions: [{ text: 'Busy' }, { text: 'Free' }]
    },
    dsSchedule: {
      labels: {
        editCustom: 'Edit'
      }
    },
    dsEvent: {
      labels: {
        moreActions: 'More actions...',
        cancel: 'Cancel event changes',
        save: 'Save',
        title: 'Title',
        exclusions: 'These are events or spans of time where a normally occurring event was excluded from the schedule. Events are excluded here if an event occurrence is moved.',
        inclusions: 'These are events or spans of time where events were added outside the normally occurring schedule. Events are added here if an event occurrence is moved.',
        cancelled: 'These are events or spans of time where events were cancelled.',
        edit: 'Edit event',
        add: 'Add event',
        location: 'Add location',
        description: 'Add description',
        calendar: 'Calendar',
        tabs: {
          details: 'Event Details',
          forecast: 'Forecast',
          removed: 'Removed',
          added: 'Added',
          cancelled: 'Cancelled'
        }
      },
      busyOptions: [{ text: 'Busy' }, { text: 'Free' }]
    },
    dsScheduleActions: {
      labels: {
        remove: 'Remove this event',
        exclude: 'Remove this occurrence',
        cancel: 'Cancel this occurrence',
        uncancel: 'Undo cancellation',
        move: 'Move this occurrence',
        include: 'Add new occurrence',
        setStart: 'Set as first occurrence',
        setEnd: 'Set as last occurrence',
        pickerOk: 'OK',
        pickerCancel: 'Cancel'
      }
    },
    dsScheduleForecast: {
      labels: {
        prefix: 'The forecast shows previous & next',
        suffix: 'event occurrences within a years time.'
      }
    },
    dsScheduleFrequencyDay: {
      labels: {
        type: 'Days'
      },
      options: [{ text: 'Any day' }, { text: 'On the following days...' }, { text: 'Every _ days starting on _' }],
      types: [{ text: 'Day of the month' }, { text: 'Last day of the month' }, { text: 'Day of the year' }]
    },
    dsScheduleFrequencyDayOfWeek: {
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      labels: {
        type: 'Days of week'
      },
      options: [{ text: 'Any day of the week' }, { text: 'On the following days of the week...' }, { text: 'Every _ weekday starting on _' }, { text: 'Weekends' }, { text: 'Weekdays' }]
    },
    dsScheduleFrequencyMonth: {
      labels: {
        type: 'Months'
      },
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      options: [{ text: 'Any month' }, { text: 'On the following months...' }, { text: 'Every _ months starting on _' }]
    },

    dsScheduleFrequencyWeek: {
      labels: {
        type: 'Weeks'
      },
      options: [{ text: 'Any week' }, { text: 'On the following weeks...' }, { text: 'Every _ weeks starting on _' }],
      types: [{ text: 'Week of the month (first week has a Thursday)' }, { text: 'Weekspan of the month (starts on first day of month)' }, { text: 'Full week of the month (0th = the week before if any)' }, { text: 'Last weekspan of the month (starts on last day of month)' }, { text: 'Last full week of the month (0th = the week after if any)' }, { text: 'Week of the year (first week has a Thursday)' }, { text: 'Weekspan of the year (starts on first day of year)' }, { text: 'Full week of the year (0th = the week before if any)' }, { text: 'Last weekspan of the year (starts on last day of year)' }, { text: 'Last full week of the year (0th = the week after if any)' }]
    },

    dsScheduleFrequencyYear: {
      labels: {
        type: 'Years'
      },
      options: [{ text: 'Any year' }, { text: 'On the following years...' }, { text: 'Every _ years starting on _' }]
    },

    dsScheduleSpan: {
      labels: {
        startless: 'Beginning of Time',
        endless: 'End of Time'
      },
      formats: {
        start: 'MMMM Do, YYYY',
        end: 'MMMM Do, YYYY'
      }
    },

    dsScheduleTime: {
      labels: {
        remove: 'Remove time',
        add: 'Add time'
      }
    },

    dsScheduleTimes: {
      labels: {
        all: 'All day',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        week: 'week',
        weeks: 'weeks',
        month: 'month',
        months: 'months',
        second: 'second',
        seconds: 'seconds'
      }
    },

    dsScheduleType: {
      formats: {
        date: 'LL'
      }
    },

    dsScheduleTypeCustomDialog: {
      labels: {
        save: 'Save',
        cancel: 'Cancel'
      }
    },

    dsWeekDayHeader: {
      formats: {
        weekday: 'ddd'
      }
    },

    dsWeeksView: {
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },

    dsDaysView: {
      hours: ['    ', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm']
    },

    dsDayPicker: {
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      labels: {
        prevMonth: 'Previous month',
        nextMonth: 'Next month'
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nl__ = __webpack_require__(59);




/* harmony default export */ __webpack_exports__["a"] = ({
  'en': __WEBPACK_IMPORTED_MODULE_0__en__["a" /* default */],
  'en-US': __WEBPACK_IMPORTED_MODULE_0__en__["a" /* default */]
});

var defaultLocale = 'en';

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var suffix = function suffix(value, prepend) {
  return (prepend ? value : '') + 'e';
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  event: 'evenement',
  promptLabels: {
    actionRemove: 'Weet je zeker dat je dit evenement wilt verwijderen?',
    actionExclude: 'Weet je zeker dat je deze instantie van het evenement wilt verwijderen?',
    actionCancel: 'Weet je zeker dat je dit evenement wilt annuleren?',
    actionUncancel: 'Weet je zeker dat je de annulering van dit evenement ongedaan wilt maken?',
    actionSetStart: 'Weet je zeker dat je deze instantie als de eerste wilt kenmerken?',
    actionSetEnd: 'Weet je zeker dat je deze instantie als de laatste wilt kenmerken?',
    actionMove: 'Weet je zeker dat je dit evenement wilt verplaatsen?',
    actionInclude: 'Weet je zeker dat je een instantie van dit evenement wilt toevoegen?',
    move: 'Weet je zeker dat je dit evement wilt verplaatsen?',
    toggleAllDay: 'Weet je zeker dat je wilt schakelen tussen hele dag en moment?',
    removeExistingTime: 'Weet je zeker dat je alle instanties van dit evenement die op het geselecteerde moment plaatsvinden wilt verwijderen?'
  },
  placeholder: {
    noTitle: '(geen titel)'
  },
  patterns: {
    lastDay: function lastDay(day) {
      return 'Laatste dag van de maand';
    },
    lastDayOfMonth: function lastDayOfMonth(day) {
      return 'Laaste dag van ' + day.toMoment().locale('nl').format('MMMM');
    },
    lastWeekday: function lastWeekday(day) {
      return 'Laatste ' + day.toMoment().locale('nl').format('dddd') + ' in ' + day.toMoment().locale('nl').format('MMMM');
    },
    none: function none() {
      return 'Geen herhaling';
    },
    daily: function daily() {
      return 'Dagelijks';
    },
    weekly: function weekly(day) {
      return 'Wekelijks op ' + day.toMoment().locale('nl').format('dddd');
    },
    monthlyWeek: function monthlyWeek(day) {
      return 'Maandelijks op de ' + suffix(day.weekspanOfMonth + 1, true) + ' ' + day.toMoment().locale('nl').format('dddd');
    },
    annually: function annually(day) {
      return 'Jaalijks op ' + day.format('D MMMM');
    },
    annuallyMonthWeek: function annuallyMonthWeek(day) {
      return 'Jaarlijks op de ' + suffix(day.weekspanOfMonth + 1, true) + ' ' + day.toMoment().locale('nl').format('dddd') + ' van ' + day.toMoment().locale('nl').format('MMMM');
    },
    weekday: function weekday(day) {
      return 'Iedere werkdag (maandag tot vrijdag)';
    },
    monthly: function monthly(day) {
      return 'Maandelijks op de ' + day.toMoment().locale('nl').format('Do') + ' dag';
    },
    custom: function custom() {
      return 'Aangepast..';
    }
  },
  schedule: {
    cancels: 'met annulering op',
    duration: 'gedurende',
    exclude: 'exclusief',
    including: 'inclusief',
    months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    range: 'Van op {:start} tot {:end}',
    rangeNoEnd: 'Vanaf {:start}',
    rangeNoStart: 'Tot {:end}',
    ruleDayOfWeek: 'dag van de week',
    ruleLastDayOfMonth: 'laatste dag van de maand',
    ruleDayOfMonth: 'dag van de maand',
    ruleDayOfYear: 'dag van het jaar',
    ruleYear: 'jaar',
    ruleMonth: 'maand',
    ruleWeekOfYear: 'week van het jaar',
    ruleWeekspanOfYear: 'weekspanne van het jaar',
    ruleFullWeekOfYear: 'volledige week van het jaar',
    ruleLastWeekspanOfYear: 'laatste weekspanne van het jaar',
    ruleLastFullWeekOfYear: 'laatste volledige week van het jaar',
    ruleWeekOfMonth: 'week van de maand',
    ruleFullWeekOfMonth: 'volledige week van de maand',
    ruleWeekspanOfMonth: 'weekspanne van de maand',
    ruleLastFullWeekOfMonth: 'laatste volledige week van de maand',
    ruleLastWeekspanOfMonth: 'laatste weekspanne van de maand',
    ruleAnd: 'en',
    ruleAny: 'een',
    ruleEvery: 'iedere',
    ruleIn: 'in',
    ruleOn: 'op',
    ruleStarts: 'vanaf',
    ruleThe: 'de',
    summaryFormat: '{:range}het {:thing} vindt plaats{:rules}{:times}{:duration}{:excludes}{:includes}{:cancels}',
    times: 'om',
    weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
  },
  formats: {
    day: function day(short, dayOfWeek, year) {
      return (dayOfWeek ? short ? 'ddd ' : 'dddd ' : '') + 'D ' + (short ? 'MMM ' : 'MMMM ') + (year ? ' YYYY' : '');
    },
    week: function week(short, dayOfWeek, year) {
      return (dayOfWeek ? short ? 'ddd ' : 'dddd ' : '') + 'D ' + (short ? 'MMM ' : 'MMMM ') + (year ? ' YYYY' : '');
    },
    month: function month(short, dayOfWeek, year) {
      return (short ? 'MMM' : 'MMMM') + (year ? ' YYYY' : '');
    },
    year: function year(short, dayOfWeek, _year) {
      return _year ? 'YYYY' : '';
    },
    timeShort: 'H:mm'
  },
  suffix: suffix,
  colors: [{ text: 'Rood' }, { text: 'Roze' }, { text: 'Paars' }, { text: 'Donkerpaars' }, { text: 'Donkerblauw' }, { text: 'Blauw' }, { text: 'Indigo' }, { text: 'Lichtblauw' }, { text: 'Cyaan' }, { text: 'Zeegroen' }, { text: 'Groen' }, { text: 'Lichtgroen' }, { text: 'Felgroen' }, { text: 'Geel' }, { text: 'Amber' }, { text: 'Oranje' }, { text: 'Donkeroranje' }, { text: 'Bruin' }, { text: 'Blauwgrijs' }, { text: 'Grijs' }, { text: 'Zwart' }],
  icons: [{ text: 'Alarm' }, { text: 'Star' }, { text: 'Love' }, { text: 'Action' }, { text: 'Assignment' }, { text: 'Warning' }, { text: 'Money' }, { text: 'Charge' }, { text: 'Home' }, { text: 'Play' }, { text: 'Email' }, { text: 'Phone' }, { text: 'Chart' }, { text: 'Biking' }, { text: 'Travel' }],
  defaults: {
    dsDay: {
      formats: {
        month: 'MMM'
      }
    },
    dsCalendarApp: {
      types: [{ label: 'Dag' }, { label: 'Week' }, { label: 'Maand' }, { label: 'Jaar' }, { label: 'Schema' }, { label: '4 dagen' }],
      formats: {
        today: 'dddd D MMMM',
        xs: 'MMM'
      },
      labels: {
        next: function next(type) {
          return type ? 'Volgend(e) ' + type.label.toLowerCase() : 'Volgende';
        },
        prev: function prev(type) {
          return type ? 'Vorig(e) ' + type.label.toLowerCase() : 'Vorig';
        },
        moveCancel: 'Verplaatsen annuleren',
        moveSingleEvent: 'Evenement verplaatsen',
        moveOccurrence: 'Verplaats alleen deze instantie van dit evenement',
        moveAll: 'Verplaats alle instanties van dit evenement',
        moveDuplicate: 'Instantie toevoegen',
        promptConfirm: 'Ja',
        promptCancel: 'Nee',
        today: 'VANDAAG'
      }
    },
    dsAgendaEvent: {
      formats: {
        firstLine: 'ddd',
        secondLine: 'D MMM',
        start: 'dddd D MMMM',
        time: 'H:mm'
      },
      labels: {
        allDay: 'Hele dag',
        options: 'Opties',
        close: 'Sluiten',
        day: ['dag', 'dagen'],
        days: ['dag', 'dagen'],
        minute: ['minuut', 'minuten'],
        minutes: ['minuut', 'minuten'],
        hour: ['uur', 'uur'],
        hours: ['uur', 'uur'],
        week: ['week', 'weken'],
        weeks: ['week', 'weken'],
        busy: 'Bezet',
        free: 'Beschikbaar'
      }
    },
    dsCalendarEventChip: {
      formats: {
        fullDay: 'ddd D MMM YYYY',
        timed: 'ddd D MMM YYYY'
      }
    },
    dsCalendarEventPopover: {
      formats: {
        start: 'dddd D MMMM',
        time: 'H:mm'
      },
      labels: {
        allDay: 'Hele dag',
        options: 'Opties',
        close: 'Sluiten',
        day: ['dag', 'dagen'],
        days: ['dag', 'dagen'],
        minute: ['minuut', 'minuten'],
        minutes: ['minuut', 'minuten'],
        hour: ['uur', 'uur'],
        hours: ['uur', 'uur'],
        week: ['week', 'weken'],
        weeks: ['week', 'weken'],
        busy: 'Bezet',
        free: 'Beschikbaar'
      }
    },
    dsCalendarEventCreatePopover: {
      formats: {
        start: 'dddd D MMMM',
        time: 'H:mm'
      },
      labels: {
        title: 'Titel',
        allDay: 'Hele dag',
        close: 'Sluiten',
        save: 'Opslaan',
        day: ['dag', 'dagen'],
        days: ['dag', 'dagen'],
        minute: ['minuut', 'minuten'],
        minutes: ['minuut', 'minuten'],
        hour: ['uur', 'uur'],
        hours: ['uur', 'uur'],
        week: ['week', 'weken'],
        weeks: ['week', 'weken'],
        busy: 'Bezet',
        free: 'Beschikbaar',
        location: 'Voeg een locatie toe',
        description: 'Voeg een beschrijving toe',
        calendar: 'Categorie'
      },
      busyOptions: [{ text: 'Bezet' }, { text: 'Beschikbaar' }]
    },
    dsSchedule: {
      labels: {
        editCustom: 'Aanpassen'
      }
    },
    dsEvent: {
      labels: {
        moreActions: 'Meer acties...',
        cancel: 'Wijzigingen annuleren',
        save: 'Opslaan',
        title: 'Titel',
        exclusions: 'Dit zijn evenementen of tijdspannes waarbij een normaliter voorkomend evenement uit het schema verwijderd is. Evenementen die verplaatst zijn verschijnen hier.',
        inclusions: 'Dit zijn evenementen of tijdspannes waarbij een evenement is toegevoegd aan het schema. Evenementen die verplaatst zijn verschijnen hier.',
        cancelled: 'Dit zijn evenementen of tijdspannes die geannulleerd zijn uit het schema.',
        edit: 'Evenement bewerken',
        add: 'Evenement toevoegen',
        location: 'Voeg een locatie toe',
        description: 'Voeg een beschrijving toe',
        calendar: 'Categorie',
        tabs: {
          details: 'Evenement',
          forecast: 'Vooruitblik',
          removed: 'Verwijderd',
          added: 'Toegevoegd',
          cancelled: 'Geannuleerd'
        }
      },
      busyOptions: [{ text: 'Bezet' }, { text: 'Beschikbaar' }]
    },
    dsScheduleActions: {
      labels: {
        remove: 'Dit evenement verwijderen',
        exclude: 'Alleen dit evenement verwijderen',
        cancel: 'Dit evenement annuleren',
        uncancel: 'Annuleren ongedaaan maken',
        move: 'Dit evenement verplaatsen',
        include: 'Voeg een nieuw evenement toe',
        setStart: 'Instellen als begin van herhaling',
        setEnd: 'Instellen als eind van herhaling',
        pickerOk: 'OK',
        pickerCancel: 'Annuleren'
      }
    },
    dsScheduleForecast: {
      labels: {
        prefix: 'De vooruitblik toont alle vorige en volgende',
        suffix: 'evenementen binnen een jaar.'
      }
    },
    dsScheduleFrequencyDay: {
      labels: {
        type: 'Dagen'
      },
      options: [{ text: 'Iedere dag' }, { text: 'Op de volgende dagen...' }, { text: 'Om de _ dagen beginnende op _' }],
      types: [{ text: 'Dag van de maand' }, { text: 'Laatste dag van de maand' }, { text: 'Dag van het jaar' }]
    },
    dsScheduleFrequencyDayOfWeek: {
      weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
      labels: {
        type: 'Dagen van de week'
      },
      options: [{ text: 'Iedere dag van de week' }, { text: 'Op de volgende dagen...' }, { text: 'Iedere _ dag van de week beginnende op _' }, { text: 'Weekenden' }, { text: 'Werkdagen' }]
    },
    dsScheduleFrequencyMonth: {
      labels: {
        type: 'Maanden'
      },
      months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
      options: [{ text: 'Iedere maand' }, { text: 'In de volgende maanden ..' }, { text: 'Iedere _ maanden beginnenden op de _' }]
    },

    dsScheduleFrequencyWeek: {
      labels: {
        type: 'Weken'
      },
      options: [{ text: 'Iedere week' }, { text: 'In de volgende weken..' }, { text: 'iedere _ weken beginnende op de _' }],
      types: [{ text: 'Week van de maand (eerste week heeft een donderdag)' }, { text: 'Weekspanne van de maand (begint op de eerste dag van de maand)' }, { text: 'Volledige week van de maand (0de = de week voorafgaande ivt)' }, { text: 'Laatste weekspanne van de maand (begint op de laatste dag van de maand)' }, { text: 'Laatste volledige week van de maand (0de = de volgende week (ivt))' }, { text: 'Week van het jaar (eerste week heeft een donderdag)' }, { text: 'Weekspanne van het jaar (begint op de eerste dag van het jaar)' }, { text: 'Volledige week van het jaar (0de = de voorafgaande week (ivt))' }, { text: 'Laatste weekspanne van het jaar (begint op de laatste dag van het jaar)' }, { text: 'Laatste volledige week van het jaar (0de = de volgende week (ivt))' }]
    },

    dsScheduleFrequencyYear: {
      labels: {
        type: 'Jaren'
      },
      options: [{ text: 'Ieder jaar' }, { text: 'In de volgende jaren...' }, { text: 'Iedere _ jaar beginnende in _' }]
    },

    dsScheduleSpan: {
      labels: {
        startless: 'Begin der tijden',
        endless: 'Einde der tijden',
        to: 'tot'
      },
      formats: {
        start: 'D MMMM YYYY',
        end: 'D MMMM YYYY'
      },
      suffix: suffix
    },

    dsScheduleTime: {
      labels: {
        remove: 'Moment verwijderen',
        add: 'Moment toevoegen'
      }
    },

    dsScheduleTimes: {
      labels: {
        all: 'Hele dag',
        minute: 'minuut',
        minutes: 'minuten',
        hour: 'uur',
        hours: 'uur',
        day: 'dag',
        days: 'dagen',
        week: 'week',
        weeks: 'weken',
        month: 'maand',
        months: 'maanden'
      }
    },

    dsScheduleType: {
      formats: {
        date: 'LL'
      }
    },

    dsScheduleTypeCustomDialog: {
      labels: {
        save: 'Opslaan',
        cancel: 'Annuleren'
      }
    },

    dsWeekDayHeader: {
      formats: {
        weekday: 'ddd'
      }
    },

    dsWeeksView: {
      weekdays: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']
    },

    dsDagenView: {
      hours: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00']
    },

    dsDayPicker: {
      weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
      labels: {
        prevMonth: 'Vorige maand',
        nextMonth: 'Volgende maand'
      }
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(62), __esModule: true };

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(60);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
var $Object = __webpack_require__(7).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(63);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(7);
var ctx = __webpack_require__(65);
var hide = __webpack_require__(69);
var has = __webpack_require__(68);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var createDesc = __webpack_require__(71);
module.exports = __webpack_require__(3) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(3) && !__webpack_require__(8)(function () {
  return Object.defineProperty(__webpack_require__(66)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(67);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(3), 'Object', { defineProperty: __webpack_require__(10).f });


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8262ea58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64bbe350",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52125556",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5325b506",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46108b38",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(172),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(156),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b314bb5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(160),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26705f1f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7461b951",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a377cd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(153),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01c6c692",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c181404",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36e040b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb16c334",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74cb2e5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(161),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30ccf664",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b1da002",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(162),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33b6bfdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0472c64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-602b721f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(152),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01507dea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(158),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18793043",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(157),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fac0c01",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e04b06c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b104ba6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9de2f668",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-746db5d7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0490c2b9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-238290c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(186),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc94a82e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(164),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45f856ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.type,
      "items": _vm.options
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), (_vm.isSimple) ? _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOneOf) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "multiple": "",
      "items": _vm.oneOfs
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.frequency.every),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "every", _vm._n($$v))
      },
      expression: "frequency.every"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.offsets
    },
    model: {
      value: (_vm.frequency.offset),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "offset", _vm._n($$v))
      },
      expression: "frequency.offset"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-placeholder",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('ds-calendar-event-time', _vm._b({
    attrs: {
      "slot": "activator",
      "is-placeholder-with-day": _vm.day,
      "calendar-event": _vm.placeholder,
      "calendar": _vm.calendar
    },
    slot: "activator"
  }, 'ds-calendar-event-time', {
    $scopedSlots: _vm.$scopedSlots
  }, false)), _vm._v(" "), _vm._t("eventCreatePopover", null, null, {
    placeholder: _vm.placeholder,
    calendar: _vm.calendar,
    day: _vm.day,
    close: _vm.close
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "persistent-hint": "",
      "items": _vm.types,
      "hint": _vm.typeHint,
      "hide-details": _vm.hideHint,
      "append-outer-icon": _vm.customIcon,
      "disabled": _vm.isReadOnly,
      "item-text": "label",
      "item-value": "value"
    },
    on: {
      "click:append-outer": _vm.custom
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-event",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "ds-event-header ds-event-area"
  }, [(_vm.hasCancel) ? _c('div', {
    staticClass: "ds-event-cancel"
  }, [_vm._t("scheduleCancel", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-button",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })], 1)], null, {
    cancel: _vm.cancel,
    labels: _vm.labels
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ds-event-actions"
  }, [_vm._t("scheduleSave", [(!_vm.isReadOnly) ? _c('v-btn', {
    staticClass: "ds-button-tall ml-3 mt-0 mb-2",
    attrs: {
      "depressed": "",
      "color": "primary",
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.save)
    }
  })]) : _vm._e()], null, {
    hasSave: _vm.hasSave,
    save: _vm.save,
    labels: _vm.labels,
    readOnly: _vm.readOnly
  }), _vm._v(" "), _vm._t("scheduleActions", [(_vm.calendarEvent && !_vm.isReadOnly) ? _c('ds-schedule-actions', _vm._g(_vm._b({
    attrs: {
      "schedule": _vm.schedule,
      "calendar-event": _vm.calendarEvent,
      "calendar": _vm.calendar
    },
    on: {
      "finish": _vm.actioned
    }
  }, 'ds-schedule-actions', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners), [_c('v-btn', {
    staticClass: "ds-button-tall ml-1 mt-0 mb-2",
    attrs: {
      "depressed": ""
    }
  }, [_vm._v("\n             " + _vm._s(_vm.labels.moreActions) + "\n          ")])], 1) : _vm._e()], null, {
    calendarEvent: _vm.calendarEvent,
    schedule: _vm.schedule,
    calendar: _vm.calendar,
    actioned: _vm.actioned,
    readOnly: _vm.readOnly
  })], 2), _vm._v(" "), _vm._t("scheduleTitle", [_c('v-text-field', {
    staticClass: "ds-event-title",
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.title,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.title),
      callback: function($$v) {
        _vm.$set(_vm.details, "title", $$v)
      },
      expression: "details.title"
    }
  })], null, {
    schedule: _vm.schedule,
    schedule: _vm.schedule,
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ds-event-body ds-event-area"
  }, [_vm._t("schedule", [_c('ds-schedule', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2), _vm._v(" "), (_vm.hasTabs) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "text--primary",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.hasDetails) ? _c('v-tab', {
    attrs: {
      "href": "#details"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.details) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showForecast) ? _c('v-tab', {
    attrs: {
      "href": "#forecast"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.forecast) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showExclusions) ? _c('v-tab', {
    attrs: {
      "href": "#exclusions"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.removed) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showInclusions) ? _c('v-tab', {
    attrs: {
      "href": "#inclusions"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.added) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showCancels) ? _c('v-tab', {
    attrs: {
      "href": "#cancelled"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labels.tabs.cancelled) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("eventTabsExtra", null, null, _vm.slotData), _vm._v(" "), (_vm.hasDetails) ? _c('v-tab-item', {
    attrs: {
      "value": "details"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventDetailsLocation", [(_vm.$dayspan.supports.location) ? _c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "location_on",
      "label": _vm.labels.location,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.location),
      callback: function($$v) {
        _vm.$set(_vm.details, "location", $$v)
      },
      expression: "details.location"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsDescription", [(_vm.$dayspan.supports.description) ? _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "single-line": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "subject",
      "label": _vm.labels.description,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.description),
      callback: function($$v) {
        _vm.$set(_vm.details, "description", $$v)
      },
      expression: "details.description"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsCalendar", [(_vm.$dayspan.supports.calendar) ? _c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "readonly": "",
      "prepend-icon": "event",
      "label": _vm.labels.calendar,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.calendar),
      callback: function($$v) {
        _vm.$set(_vm.details, "calendar", $$v)
      },
      expression: "details.calendar"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsColor", [(_vm.$dayspan.supports.color) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "invert_colors",
      "items": _vm.$dayspan.colors,
      "color": _vm.details.color,
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-content', [_c('div', {
          staticClass: "ds-color-option",
          style: ({
            backgroundColor: item.value
          }),
          domProps: {
            "textContent": _vm._s(item.text)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.details.color),
      callback: function($$v) {
        _vm.$set(_vm.details, "color", $$v)
      },
      expression: "details.color"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsIcon", [(_vm.$dayspan.supports.icon) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": _vm.details.icon || 'help',
      "items": _vm.$dayspan.icons,
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.value))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])]
      }
    }]),
    model: {
      value: (_vm.details.icon),
      callback: function($$v) {
        _vm.$set(_vm.details, "icon", $$v)
      },
      expression: "details.icon"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsBusy", [(_vm.$dayspan.supports.busy) ? _c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "prepend-icon": "work",
      "items": _vm.busyOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.details.busy),
      callback: function($$v) {
        _vm.$set(_vm.details, "busy", $$v)
      },
      expression: "details.busy"
    }
  }) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventDetailsExtra", null, null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showForecast) ? _c('v-tab-item', {
    attrs: {
      "value": "forecast",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventForecast", [_c('ds-schedule-forecast', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showExclusions) ? _c('v-tab-item', {
    attrs: {
      "value": "exclusions",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventExclusions", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.exclusions,
      "modifier": _vm.schedule.exclude,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showInclusions) ? _c('v-tab-item', {
    attrs: {
      "value": "inclusions",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventInclusions", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.inclusions,
      "modifier": _vm.schedule.include,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCancels) ? _c('v-tab-item', {
    attrs: {
      "value": "cancelled",
      "lazy": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("eventCancels", [_c('ds-schedule-modifier', {
    attrs: {
      "description": _vm.labels.cancelled,
      "modifier": _vm.schedule.cancel,
      "read-only": _vm.readOnly
    }
  })], null, _vm.slotData)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("eventTabItemsExtra", null, null, _vm.slotData)], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ds-calendar-event-popover-card",
    class: _vm.classes
  }, [_c('v-toolbar', {
    style: (_vm.styleHeader),
    attrs: {
      "extended": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "autofocus": "",
      "label": _vm.labels.title
    },
    model: {
      value: (_vm.details.title),
      callback: function($$v) {
        _vm.$set(_vm.details, "title", $$v)
      },
      expression: "details.title"
    }
  })], 1), _vm._v(" "), (!_vm.details.readonly) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "absolute": "",
      "bottom": "",
      "left": "",
      "fab": "",
      "icon": ""
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.edit))])], 1) : _vm._e(), _vm._v(" "), _vm._t("eventCreatePopoverToolbarLeft", null, null, _vm.slotData), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("eventCreatePopoverToolbarRight", null, null, _vm.slotData), _vm._v(" "), _vm._t("eventCreatePopoverToolbarSave", [_c('v-btn', {
    staticClass: "ds-create-popover-save",
    style: (_vm.styleText),
    attrs: {
      "flat": "",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.icons.save))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.save))])], 1)], null, _vm.slotData), _vm._v(" "), _vm._t("eventCreatePopoverToolbarClose", [_c('v-btn', {
    style: (_vm.styleText),
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.close))])], 1)], null, _vm.slotData)], 2), _vm._v(" "), _c('v-card-text', [_vm._t("eventCreatePopoverBodyTop", null, null, _vm.slotData), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverOccurs", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.occurs))])], null, _vm.slotData)], 2)], 1), _vm._v(" "), (_vm.prompts.location && _vm.$dayspan.supports.location) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverLocation", [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.location
    },
    model: {
      value: (_vm.details.location),
      callback: function($$v) {
        _vm.$set(_vm.details, "location", $$v)
      },
      expression: "details.location"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.description && _vm.$dayspan.supports.description) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverDescription", [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "single-line": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.description
    },
    model: {
      value: (_vm.details.description),
      callback: function($$v) {
        _vm.$set(_vm.details, "description", $$v)
      },
      expression: "details.description"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.calendar && _vm.$dayspan.supports.calendar) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverCalendar", [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "label": _vm.labels.calendar
    },
    model: {
      value: (_vm.details.calendar),
      callback: function($$v) {
        _vm.$set(_vm.details, "calendar", $$v)
      },
      expression: "details.calendar"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.color && _vm.$dayspan.supports.color) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("invert_colors")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverColor", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.$dayspan.colors,
      "color": _vm.details.color
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-content', [_c('div', {
          staticClass: "ds-color-option",
          style: ({
            backgroundColor: item.value
          }),
          domProps: {
            "textContent": _vm._s(item.text)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.details.color),
      callback: function($$v) {
        _vm.$set(_vm.details, "color", $$v)
      },
      expression: "details.color"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.icon && _vm.$dayspan.supports.icon) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(_vm.details.icon || 'help'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverIcon", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.$dayspan.icons
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.value))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])]
      }
    }]),
    model: {
      value: (_vm.details.icon),
      callback: function($$v) {
        _vm.$set(_vm.details, "icon", $$v)
      },
      expression: "details.icon"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.prompts.busy && _vm.$dayspan.supports.busy) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventCreatePopoverBusy", [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "full-width": "",
      "items": _vm.busyOptions
    },
    model: {
      value: (_vm.details.busy),
      callback: function($$v) {
        _vm.$set(_vm.details, "busy", $$v)
      },
      expression: "details.busy"
    }
  })], null, _vm.slotData)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _vm._t("eventCreatePopoverBodyBottom", null, null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventCreatePopoverActions", null, null, _vm.slotData)], 2)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.type,
      "items": _vm.options
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), (_vm.isAny) ? _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isAny) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "return-object": "",
      "items": _vm.types
    },
    model: {
      value: (_vm.chosenType),
      callback: function($$v) {
        _vm.chosenType = $$v
      },
      expression: "chosenType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isOneOf) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": "",
      "offset-xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "multiple": "",
      "items": _vm.oneOfs
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs2": "",
      "offset-xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.frequency.every),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "every", _vm._n($$v))
      },
      expression: "frequency.every"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.offsets
    },
    model: {
      value: (_vm.frequency.offset),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "offset", _vm._n($$v))
      },
      expression: "frequency.offset"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.type,
      "items": _vm.options
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), (_vm.isAny) ? _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOneOf) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "multiple": "",
      "items": _vm.oneOfs
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.frequency.every),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "every", _vm._n($$v))
      },
      expression: "frequency.every"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.offsets
    },
    model: {
      value: (_vm.frequency.offset),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "offset", _vm._n($$v))
      },
      expression: "frequency.offset"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMoveDay($event)
      },
      "mousedown": _vm.mouseDownDay,
      "mouseup": _vm.mouseUpDay,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ds-week-weekday"
  }, [_vm._v("\n    " + _vm._s(_vm.weekday) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "ds-week-date",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.viewDay($event)
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.dayOfMonth) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-all-events"
  }, [_vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-calendar-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "index": i,
        "calendar": _vm.calendar
      }
    }, 'ds-calendar-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  }), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar,
      "index": _vm.visibleEvents.length
    }
  }, 'ds-calendar-event-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('ds-calendar-event', _vm._b({
    attrs: {
      "slot": "activator",
      "is-placeholder-with-day": _vm.day,
      "calendar-event": _vm.placeholder,
      "calendar": _vm.calendar,
      "index": _vm.index
    },
    slot: "activator"
  }, 'ds-calendar-event', {
    $scopedSlots: _vm.$scopedSlots
  }, false)), _vm._v(" "), _vm._t("eventCreatePopover", null, null, {
    placeholder: _vm.placeholder,
    calendar: _vm.calendar,
    day: _vm.day,
    index: _vm.index,
    close: _vm.close
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week-view-container"
  }, [_c('ds-week-header', _vm._g(_vm._b({
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "days": _vm.calendar.days,
      "scroll-push": _vm.scrollPush
    }
  }, 'ds-week-header', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners)), _vm._v(" "), _c('div', {
    staticClass: "ds-week-view-bottom"
  }, [_c('div', {
    ref: "scrollArea",
    staticClass: "ds-week-view-scrollable"
  }, [_c('div', {
    ref: "pane",
    staticClass: "ds-week-view-pane",
    style: (_vm.dayHeight)
  }, [_c('div', {
    staticClass: "ds-week"
  }, [_c('div', {
    staticClass: "ds-hour-list"
  }, _vm._l((_vm.hours), function(hour, i) {
    return _c('div', {
      staticClass: "ds-hour",
      class: _vm.hourClasses[i]
    }, [_c('div', {
      staticClass: "ds-hour-text"
    }, [_vm._v(_vm._s(hour))])])
  })), _vm._v(" "), _vm._l((_vm.calendar.days), function(day) {
    return [_c('ds-day-times', _vm._g(_vm._b({
      key: day.dayIdentifier,
      attrs: {
        "day": day,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate,
        "calendar": _vm.calendar
      }
    }, 'ds-day-times', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-gesture-container",
    on: {
      "touchstart": _vm.start,
      "touchmove": _vm.move,
      "touchend": _vm.end
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day-picker"
  }, [_c('div', {
    staticClass: "ds-week-header mb-2"
  }, [_c('div', {
    staticClass: "subtitle py-1 pl-2 ds-light-forecolor"
  }, [_vm._v("\n      " + _vm._s(_vm.summary) + "\n    ")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ma-0",
    attrs: {
      "slot": "activator",
      "small": "",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.prev
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.prevMonth))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ma-0",
    attrs: {
      "slot": "activator",
      "small": "",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.next
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.nextMonth))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-week-subheader ds-light-forecolor"
  }, _vm._l((_vm.weekdays), function(weekday) {
    return _c('div', {
      key: weekday,
      staticClass: "ds-weekday"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_vm._v(_vm._s(weekday.charAt(0)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(weekday))])])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "ds-week"
  }, _vm._l((_vm.month.days), function(day) {
    return _c('div', {
      key: day.dayIdentifier,
      staticClass: "ds-day-pick"
    }, [_c('v-btn', {
      staticClass: "ma-0",
      class: {
        'btn--active': day.currentDay,
          'ds-light-forecolor': !day.inCalendar,
          'primary': _vm.isHighlighted(day)
      },
      attrs: {
        "small": "",
        "icon": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          _vm.pick(day)
        }
      }
    }, [_vm._v("\n        " + _vm._s(day.dayOfMonth) + "\n      ")])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-month"
  }, [_c('div', {
    staticClass: "ds-week-header"
  }, _vm._l((_vm.weekdays), function(weekday, i) {
    return _c('div', {
      key: weekday,
      staticClass: "ds-week-header-day",
      class: _vm.weekdayClasses(i)
    }, [_vm._v("\n\n      " + _vm._s(weekday) + "\n\n    ")])
  })), _vm._v(" "), _vm._l((_vm.rows), function(i) {
    return _c('ds-day-row', _vm._g(_vm._b({
      key: i,
      attrs: {
        "days": _vm.daysAtRow(i, 7),
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-day-row', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('div', {
    staticClass: "ds-calendar-event",
    style: (_vm.style),
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editCheck($event)
      },
      "mouseenter": _vm.mouseEnterEvent,
      "mouseleave": _vm.mouseLeaveEvent,
      "mousedown": _vm.mouseDownEvent,
      "mouseup": _vm.mouseUpEvent
    },
    slot: "activator"
  }, [(_vm.showName) ? _c('span', [_vm._t("eventTitle", [(_vm.hasIcon) ? _c('v-icon', {
    staticClass: "ds-ev-icon",
    style: ({
      color: _vm.details.forecolor
    }),
    attrs: {
      "size": "14"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.details.icon) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.hasPrefix) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.getPrefix) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    staticClass: "ds-ev-title"
  }, [_vm._v(_vm._s(_vm.details.title))]), _vm._v(" "), _c('span', {
    staticClass: "ds-ev-description"
  }, [_vm._v(_vm._s(_vm.details.description))])], null, {
    calendarEvent: _vm.calendarEvent,
    hasPrefix: _vm.hasPrefix,
    getPrefix: _vm.getPrefix,
    details: _vm.details
  })], 2) : _c('span', [_vm._t("eventEmpty", [_vm._v(" ")], null, {
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2)]), _vm._v(" "), _vm._t("eventPopover", null, null, {
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar,
    edit: _vm.edit,
    details: _vm.details,
    close: _vm.close
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-chip', {
    attrs: {
      "label": "",
      "close": _vm.canRemove
    },
    on: {
      "input": _vm.remove
    }
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMoveDay($event)
      },
      "mousedown": _vm.mouseDownDay,
      "mouseup": _vm.mouseUpDay,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    class: _vm.classesHeader
  }, [_c('a', {
    staticClass: "ds-dom",
    class: _vm.classesDayOfMonth,
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.viewDay($event)
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.dayOfMonth) + "\n    ")]), _vm._v(" "), (_vm.showMonth) ? _c('span', {
    staticClass: "ds-first-day"
  }, [_vm._v("\n      " + _vm._s(_vm.month) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-calendar-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "calendar": _vm.calendar,
        "index": i
      }
    }, 'ds-calendar-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  }), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar,
      "index": _vm.visibleEvents.length
    }
  }, 'ds-calendar-event-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.type,
      "items": _vm.options
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), (_vm.isAny) ? _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOneOf) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "multiple": "",
      "items": _vm.oneOfs
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.frequency.every),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "every", _vm._n($$v))
      },
      expression: "frequency.every"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.offsets
    },
    model: {
      value: (_vm.frequency.offset),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "offset", _vm._n($$v))
      },
      expression: "frequency.offset"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "ds-agenda-event",
    class: _vm.classes
  }, [(_vm.first) ? _c('td', {
    staticClass: "ds-agenda-lines",
    attrs: {
      "rowspan": _vm.siblings
    }
  }, [_vm._t("agendaDayDate", [_c('div', {
    staticClass: "ds-agenda-line-first"
  }, [_vm._v("\n        " + _vm._s(_vm.firstLine) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-agenda-line-second",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.viewDay($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.secondLine) + "\n      ")])], null, _vm.slotData)], 2) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "ds-agenda-when",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("agendaEventWhen", [_vm._v("\n\n      " + _vm._s(_vm.when) + "\n\n    ")], null, _vm.slotData)], 2), _vm._v(" "), _c('td', {
    staticClass: "ds-agenda-details",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editCheck($event)
      }
    }
  }, [_c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('div', {
    staticClass: "ds-agenda-activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("agendaEventDetails", [(_vm.details.icon) ? _c('v-icon', {
    staticClass: "ds-details-icon",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.details.icon) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ds-details-description",
    domProps: {
      "innerHTML": _vm._s(_vm.details.description)
    }
  })], null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventPopover", null, null, {
    readOnly: _vm.readOnly,
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar,
    edit: _vm.edit,
    details: _vm.details,
    close: _vm.close
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-calendar"
  }, [(_vm.isYear) ? _c('div', {
    staticClass: "ds-month-view ds-year-view"
  }, [_c('ds-weeks-view', _vm._g(_vm._b({
    staticClass: "ds-expand",
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-weeks-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e(), _vm._v(" "), (_vm.isMonth) ? _c('div', {
    staticClass: "ds-month-view"
  }, [_c('ds-weeks-view', _vm._g(_vm._b({
    staticClass: "ds-expand",
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-weeks-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e(), _vm._v(" "), (_vm.isWeek || _vm.isDay) ? _c('div', {
    staticClass: "ds-week-view"
  }, [_c('ds-days-view', _vm._g(_vm._b({
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move": _vm.mouseMove,
      "mouse-down": _vm.mouseDown,
      "mouse-up": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-days-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-expand ds-calendar-app"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_vm._t("drawerTop"), _vm._v(" "), _vm._t("drawerPicker", [(_vm.calendar) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('ds-day-picker', {
    attrs: {
      "span": _vm.calendar.span
    },
    on: {
      "picked": _vm.rebuild
    }
  })], 1) : _vm._e()], {
    calendar: _vm.calendar,
    picked: _vm.rebuild
  }), _vm._v(" "), _vm._t("drawerBottom")], 2), _vm._v(" "), _c('v-toolbar', {
    staticClass: "ds-app-calendar-toolbar",
    attrs: {
      "app": "",
      "flat": "",
      "fixed": "",
      "color": "white",
      "clipped-left": _vm.$vuetify.breakpoint.lgAndUp
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    style: (_vm.toolbarStyle)
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._t("title", null, {
    calendar: _vm.calendar
  })], 2)], 1), _vm._v(" "), _vm._t("today", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-skinny-button",
    attrs: {
      "slot": "activator",
      "depressed": "",
      "icon": _vm.$vuetify.breakpoint.smAndDown
    },
    on: {
      "click": _vm.setToday
    },
    slot: "activator"
  }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('span', [_vm._v(_vm._s(_vm.labels.today))]) : _c('v-icon', [_vm._v(_vm._s(_vm.labels.todayIcon))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.todayDate))])], 1)], null, {
    setToday: _vm.setToday,
    todayDate: _vm.todayDate,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("prev", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ds-skinny-button",
    attrs: {
      "slot": "activator",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.prev
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevLabel))])], 1)], null, {
    prev: _vm.prev,
    prevLabel: _vm.prevLabel,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("next", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ds-skinny-button",
    attrs: {
      "slot": "activator",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.next
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.nextLabel))])], 1)], null, {
    next: _vm.next,
    nextLabel: _vm.nextLabel,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("summary", [_c('h1', {
    staticClass: "title ds-light-forecolor"
  }, [_vm._v("\n        " + _vm._s(_vm.summary) + "\n      ")])], null, {
    summary: _vm.summary,
    calendar: _vm.calendar
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("view", [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n          " + _vm._s(_vm.currentType.label) + "\n          "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.types), function(type) {
    return _c('v-list-tile', {
      key: type.id,
      on: {
        "click": function($event) {
          _vm.currentType = type
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(type.label))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(type.shortcut))])], 1)
  }))], 1)], null, {
    currentType: _vm.currentType,
    types: _vm.types
  }), _vm._v(" "), _vm._t("menuRight")], 2), _vm._v(" "), _c('v-content', {
    staticClass: "ds-expand"
  }, [_c('v-container', {
    staticClass: "ds-calendar-container",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('ds-gestures', {
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev
    }
  }, [(_vm.currentType.schedule) ? _c('div', {
    staticClass: "ds-expand"
  }, [_vm._t("calendarAppAgenda", [_c('ds-agenda', _vm._g(_vm._b({
    attrs: {
      "read-only": _vm.readOnly,
      "calendar": _vm.calendar
    },
    on: {
      "add": _vm.add,
      "edit": _vm.edit,
      "view-day": _vm.viewDay
    }
  }, 'ds-agenda', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    add: _vm.add,
    edit: _vm.edit,
    viewDay: _vm.viewDay
  })], 2) : _c('div', {
    staticClass: "ds-expand"
  }, [_vm._t("calendarAppCalendar", [_c('ds-calendar', _vm._g(_vm._b({
    ref: "calendar",
    attrs: {
      "calendar": _vm.calendar,
      "read-only": _vm.readOnly
    },
    on: {
      "add": _vm.add,
      "add-at": _vm.addAt,
      "edit": _vm.edit,
      "view-day": _vm.viewDay,
      "added": _vm.handleAdd,
      "moved": _vm.handleMove
    }
  }, 'ds-calendar', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    add: _vm.add,
    addAt: _vm.addAt,
    edit: _vm.edit,
    viewDay: _vm.viewDay,
    handleAdd: _vm.handleAdd,
    handleMove: _vm.handleMove
  })], 2)]), _vm._v(" "), _vm._t("calendarAppEventDialog", [_c('ds-event-dialog', _vm._g(_vm._b({
    ref: "eventDialog",
    attrs: {
      "calendar": _vm.calendar,
      "read-only": _vm.readOnly
    },
    on: {
      "saved": _vm.eventFinish,
      "actioned": _vm.eventFinish
    }
  }, 'ds-event-dialog', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    eventFinish: _vm.eventFinish
  }), _vm._v(" "), _vm._t("calendarAppOptions", [_c('v-dialog', _vm._b({
    ref: "optionsDialog",
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.optionsVisible),
      callback: function($$v) {
        _vm.optionsVisible = $$v
      },
      expression: "optionsVisible"
    }
  }, 'v-dialog', _vm.optionsDialog, false), [_c('v-list', [_vm._l((_vm.options), function(option) {
    return [_c('v-list-tile', {
      key: option.text,
      on: {
        "click": function($event) {
          _vm.chooseOption(option)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.text) + "\n              ")])]
  })], 2)], 1)], null, {
    optionsVisible: _vm.optionsVisible,
    optionsDialog: _vm.optionsDialog,
    options: _vm.options,
    chooseOption: _vm.chooseOption
  }), _vm._v(" "), _vm._t("calendarAppPrompt", [_c('v-dialog', _vm._b({
    ref: "promptDialog",
    model: {
      value: (_vm.promptVisible),
      callback: function($$v) {
        _vm.promptVisible = $$v
      },
      expression: "promptVisible"
    }
  }, 'v-dialog', _vm.promptDialog, false), [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.promptQuestion))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePrompt(true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labels.promptConfirm) + "\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePrompt(false)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labels.promptCancel) + "\n              ")])], 1)], 1)], 1)], null, {
    promptVisible: _vm.promptVisible,
    promptDialog: _vm.promptDialog,
    promptQuestion: _vm.promptQuestion,
    choosePrompt: _vm.choosePrompt
  }), _vm._v(" "), _vm._t("calendarAppAdd", [(!_vm.readOnly) ? _c('v-fab-transition', [_c('v-btn', {
    staticClass: "ds-add-event-today",
    attrs: {
      "color": "primary",
      "fixed": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": _vm.addToday
    },
    model: {
      value: (_vm.allowsAddToday),
      callback: function($$v) {
        _vm.allowsAddToday = $$v
      },
      expression: "allowsAddToday"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1) : _vm._e()], null, {
    allowsAddToday: _vm.allowsAddToday,
    addToday: _vm.addToday
  }), _vm._v(" "), _vm._t("containerInside", null, null, {
    events: _vm.events,
    calendar: _vm.calendar
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-chip', {
    attrs: {
      "label": "",
      "close": _vm.canExclude,
      "color": _vm.background,
      "text-color": _vm.foreground
    },
    on: {
      "input": _vm.exclude
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', _vm._b({
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.open),
      callback: function($$v) {
        _vm.open = $$v
      },
      expression: "open"
    }
  }, 'v-dialog', _vm.dialogProps, false), [(_vm.schedule && _vm.details) ? _c('v-card', [_c('v-card-text', [_c('ds-event', _vm._b({
    attrs: {
      "target-details": _vm.details,
      "target-schedule": _vm.schedule,
      "calendar": _vm.calendar,
      "calendar-event": _vm.calendarEvent,
      "day": _vm.day,
      "read-only": _vm.readOnly
    },
    on: {
      "saved": _vm.saved,
      "cancel": _vm.cancel,
      "actioned": _vm.actioned,
      "event-create": _vm.eventCreate,
      "event-update": _vm.eventUpdate,
      "event-remove": _vm.eventRemove
    }
  }, 'ds-event', {
    $scopedSlots: _vm.$scopedSlots
  }, false))], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "label": _vm.labels.type,
      "items": _vm.options
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), (_vm.isAny) ? _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isAny) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "return-object": "",
      "items": _vm.types
    },
    model: {
      value: (_vm.chosenType),
      callback: function($$v) {
        _vm.chosenType = $$v
      },
      expression: "chosenType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isOneOf) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs5": "",
      "offset-xs7": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "multiple": "",
      "solo": "",
      "flat": "",
      "items": _vm.oneOfs
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs2": "",
      "offset-xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.frequency.every),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "every", _vm._n($$v))
      },
      expression: "frequency.every"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEvery) ? _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.offsets
    },
    model: {
      value: (_vm.frequency.offset),
      callback: function($$v) {
        _vm.$set(_vm.frequency, "offset", _vm._n($$v))
      },
      expression: "frequency.offset"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "ds-agenda-day",
    class: _vm.classes,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-agenda-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "read-only": _vm.readOnly,
        "calendar-event": event,
        "calendar": _vm.calendar,
        "first": i === 0,
        "siblings": _vm.visibleEvents.length
      }
    }, 'ds-agenda-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasDescription) ? _c('div', {
    staticClass: "pb-3"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.prefix)
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "ds-textfield inline small",
    attrs: {
      "type": "number",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.sizeInput),
      callback: function($$v) {
        _vm.sizeInput = _vm._n($$v)
      },
      expression: "sizeInput"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.suffix)
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.forecast), function(time) {
    return [_c('ds-calendar-event-chip', {
      key: time.time,
      attrs: {
        "day": _vm.aroundDay,
        "time": time,
        "can-exclude": _vm.canExclude && !_vm.isReadOnly
      },
      on: {
        "exclude": _vm.exclude
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ds-calendar-event-popover-card",
    class: _vm.classes
  }, [_c('v-toolbar', {
    style: (_vm.styleHeader),
    attrs: {
      "extended": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_vm._v("\n     " + _vm._s(_vm.details.title) + "\n     "), (_vm.details.icon) ? _c('v-icon', {
    style: (_vm.styleButton)
  }, [_vm._v("\n       " + _vm._s(_vm.details.icon) + "\n     ")]) : _vm._e()], 1), _vm._v(" "), (_vm.allowEdit) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "absolute": "",
      "bottom": "",
      "left": "",
      "fab": "",
      "icon": ""
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _vm._t("eventPopoverToolbarLeft", null, null, _vm.slotData), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("eventPopoverToolbarRight", null, null, _vm.slotData), _vm._v(" "), _vm._t("eventPopoverToolbarActions", [(!_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('ds-schedule-actions', _vm._g(_vm._b({
    attrs: {
      "slot": "activator",
      "schedule": _vm.calendarEvent.schedule,
      "calendar-event": _vm.calendarEvent,
      "calendar": _vm.calendar
    },
    slot: "activator"
  }, 'ds-schedule-actions', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners), [_c('v-btn', {
    style: (_vm.styleButton),
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels.options))])], 1) : _vm._e()], null, _vm.slotData), _vm._v(" "), _vm._t("eventPopoverToolbarClose", [_c('v-btn', {
    style: (_vm.styleButton),
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], null, _vm.slotData)], 2), _vm._v(" "), _c('v-card-text', [_vm._t("eventPopoverBodyTop", null, null, _vm.slotData), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverOccurs", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.occurs))])], null, _vm.slotData)], 2)], 1), _vm._v(" "), (_vm.details.location) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverLocation", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.location)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.description) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverDescription", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.description)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.notify) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("notifications")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverNotifications", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.notify)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.details.calendar) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverCalendar", [_c('v-list-tile-title', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.calendar)
    }
  })])], null, _vm.slotData)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.hasBusy) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._t("eventPopoverBusy", [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.busyness))])], null, _vm.slotData)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _vm._t("eventPopoverBodyBottom", null, null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventPopoverActions", null, null, _vm.slotData)], 2)
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-schedule-times"
  }, [_c('div', {
    staticClass: "ds-time-row"
  }, [_c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-checkbox', {
    ref: "allDayCheckbox",
    staticClass: "ma-2",
    attrs: {
      "hide-details": "",
      "label": _vm.labels.all,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.allDay),
      callback: function($$v) {
        _vm.allDay = $$v
      },
      expression: "allDay"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "type": "number",
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.triggerChange
    },
    model: {
      value: (_vm.schedule.duration),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "duration", _vm._n($$v))
      },
      expression: "schedule.duration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "items": _vm.durationOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.triggerChange
    },
    model: {
      value: (_vm.schedule.durationUnit),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "durationUnit", $$v)
      },
      expression: "schedule.durationUnit"
    }
  })], 1)]), _vm._v(" "), (!_vm.allDay) ? _c('div', _vm._l((_vm.schedule.times), function(time, index) {
    return _c('div', {
      staticClass: "ds-time-row"
    }, [_c('div', {
      staticClass: "ds-time-cell"
    }), _vm._v(" "), _c('ds-schedule-time', {
      key: index,
      staticClass: "ds-time-cell double",
      attrs: {
        "index": index,
        "show-add": _vm.isLastTime(index),
        "show-remove": _vm.hasTimes,
        "value": _vm.schedule.times[index],
        "read-only": _vm.readOnly
      },
      on: {
        "add": _vm.addTime,
        "remove": _vm.removeTime,
        "change": _vm.changeTime
      }
    })], 1)
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMove($event)
      },
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((24), function(h) {
    return _c('div', {
      staticClass: "ds-hour",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addAt(h)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.day.events), function(event, i) {
    return [(_vm.isVisible(event)) ? _c('ds-calendar-event-time', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "calendar": _vm.calendar
      }
    }, 'ds-calendar-event-time', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners)) : _vm._e()]
  }), _vm._v(" "), (_vm.day.currentDay) ? _c('div', {
    style: (_vm.nowLine)
  }) : _vm._e(), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-time-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar
    }
  }, 'ds-calendar-event-time-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event",
    style: (_vm.style),
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('div', {
    staticClass: "ds-calendar-event-span",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": _vm.editCheck,
      "mouseenter": _vm.mouseEnterEvent,
      "mouseleave": _vm.mouseLeaveEvent,
      "mousedown": _vm.mouseDownEvent,
      "mouseup": _vm.mouseUpEvent
    },
    slot: "activator"
  }, [(_vm.showName) ? _c('span', [_vm._t("eventTimeTitle", [(_vm.hasIcon) ? _c('v-icon', {
    staticClass: "ds-ev-icon",
    style: ({
      color: _vm.details.forecolor
    }),
    attrs: {
      "size": "14"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.details.icon) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    staticClass: "ds-ev-title"
  }, [_vm._v(_vm._s(_vm.details.title))]), _vm._v(" "), _c('span', {
    staticClass: "ds-ev-description"
  }, [_vm._v(_vm._s(_vm.details.description))])], null, {
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2) : _c('span', [_vm._t("eventTimeEmpty", null, null, {
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2)]), _vm._v(" "), _vm._t("eventPopover", null, null, {
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar,
    edit: _vm.edit,
    details: _vm.details,
    close: _vm.close
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ds-agenda-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.eventDays), function(day) {
    return [_c('ds-agenda-day', _vm._g(_vm._b({
      key: day.dayIdentifier,
      attrs: {
        "read-only": _vm.readOnly,
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-agenda-day', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "column-day"
  }), _vm._v(" "), _c('col', {
    staticClass: "column-when"
  }), _vm._v(" "), _c('col', {
    staticClass: "column-event"
  })])
}]}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.description) ? _c('div', {
    staticClass: "pb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.identifiers), function(id) {
    return [_c('ds-identifier-chip', {
      key: id,
      attrs: {
        "identifier": id,
        "can-remove": _vm.canRemove && !_vm.isReadOnly
      },
      on: {
        "remove": _vm.remove
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-time-row"
  }, [_c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "type": "time",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [(_vm.showRemove && !_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-remove",
    attrs: {
      "slot": "activator",
      "icon": "",
      "color": _vm.colors.remove
    },
    on: {
      "click": _vm.removeTime
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.remove))])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.remove)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd && !_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-add",
    attrs: {
      "slot": "activator",
      "icon": "",
      "color": _vm.colors.add
    },
    on: {
      "click": _vm.addTime
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.add))])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.add)
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-schedule",
    class: _vm.classes
  }, [(_vm.showRange) ? _c('div', {
    staticClass: "ds-schedule-span"
  }, [_vm._t("scheduleSpan", [_c('ds-schedule-span', {
    attrs: {
      "schedule": _vm.schedule,
      "day": _vm.day,
      "read-only": _vm.readOnly
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ds-schedule-type-line"
  }, [_c('div', {
    staticClass: "ds-schedule-type"
  }, [_vm._t("scheduleType", [_c('ds-schedule-type', {
    attrs: {
      "day": _vm.day,
      "schedule": _vm.schedule,
      "read-only": _vm.readOnly
    },
    on: {
      "change": _vm.setType,
      "custom": _vm.custom
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day,
    setType: _vm.setType,
    custom: _vm.custom
  })], 2)]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("scheduleTimes", [_c('ds-schedule-times', {
    attrs: {
      "schedule": _vm.schedule,
      "read-only": _vm.readOnly
    }
  })], null, {
    schedule: _vm.schedule,
    day: _vm.day
  })], 2), _vm._v(" "), (!_vm.isReadOnly) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._t("scheduleFooter", null, null, {
    schedule: _vm.schedule,
    day: _vm.day
  }), _vm._v(" "), _c('ds-schedule-type-custom-dialog', _vm._b({
    ref: "customScheduler"
  }, 'ds-schedule-type-custom-dialog', {
    $scopedSlots: _vm.$scopedSlots
  }, false))], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 60,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.startMenu),
      callback: function($$v) {
        _vm.startMenu = $$v
      },
      expression: "startMenu"
    }
  }, [_c('v-btn', {
    staticClass: "ds-button-tall ma-0 mb-2",
    attrs: {
      "slot": "activator",
      "depressed": ""
    },
    slot: "activator"
  }, [_vm._v("\n      " + _vm._s(_vm.startText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-span-menu"
  }, [_c('ds-day-picker', {
    attrs: {
      "highlight-span": _vm.hasStart,
      "span": _vm.startSpan
    },
    on: {
      "picked": _vm.setStart
    }
  }), _vm._v(" "), (_vm.hasStart) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.setStart(null)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.startless)
    }
  })]) : _vm._e()], 1)], 1), _vm._v("\n\n    to  \n\n  "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 60,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.endMenu),
      callback: function($$v) {
        _vm.endMenu = $$v
      },
      expression: "endMenu"
    }
  }, [_c('v-btn', {
    staticClass: "ds-button-tall ma-0 mb-2",
    attrs: {
      "slot": "activator",
      "depressed": ""
    },
    slot: "activator"
  }, [_vm._v("\n      " + _vm._s(_vm.endText) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-span-menu"
  }, [_c('ds-day-picker', {
    attrs: {
      "highlight-span": _vm.hasEnd,
      "span": _vm.endSpan
    },
    on: {
      "picked": _vm.setEnd
    }
  }), _vm._v(" "), (_vm.hasEnd) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.setEnd(null)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.endless)
    }
  })]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week-header",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "ds-hour-list"
  }), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return [_c('ds-week-day-header', _vm._g(_vm._b({
      attrs: {
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-week-day-header', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', _vm._b({
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, 'v-dialog', _vm.dialogProps, false), [(_vm.hasData) ? _c('v-card', [_vm._t("scheduleTypeCustomHeader", null, null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day
  }), _vm._v(" "), _c('v-card-text', [_vm._t("scheduleTypeCustomBody", [_c('ds-schedule-type-custom', {
    attrs: {
      "schedule": _vm.copy,
      "day": _vm.aroundDay
    }
  })], null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_vm._t("scheduleTypeCustomActions", [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.save)
    }
  })])], null, {
    original: _vm.original,
    copy: _vm.copy,
    aroundDay: _vm.aroundDay,
    day: _vm.day,
    cancel: _vm.cancel,
    save: _vm.save,
    labels: _vm.labels
  })], 2)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('template', {
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-list', [(_vm.canRemove) ? _c('v-list-tile', {
    on: {
      "click": _vm.remove
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.remove)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canExclude) ? _c('v-list-tile', {
    on: {
      "click": _vm.exclude
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.exclude)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canCancel) ? _c('v-list-tile', {
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.cancel)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canUncancel) ? _c('v-list-tile', {
    on: {
      "click": _vm.uncancel
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.uncancel)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSetStart) ? _c('v-list-tile', {
    on: {
      "click": _vm.setStart
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.setStart)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSetEnd) ? _c('v-list-tile', {
    on: {
      "click": _vm.setEnd
    }
  }, [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.setEnd)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canMove) ? _c('v-list-tile', {
    on: {
      "click": _vm.moveStart
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "min-width": "290px",
      "color": "primary",
      "close-on-content-click": false,
      "nudge-right": 40
    },
    model: {
      value: (_vm.moving),
      callback: function($$v) {
        _vm.moving = $$v
      },
      expression: "moving"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.move)
    }
  })]), _vm._v(" "), (_vm.movingDate) ? _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetDate),
      callback: function($$v) {
        _vm.targetDate = $$v
      },
      expression: "targetDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.movingDate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.moveEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e(), _vm._v(" "), (_vm.movingTime) ? _c('v-time-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetTime),
      callback: function($$v) {
        _vm.targetTime = $$v
      },
      expression: "targetTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.movingTime = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.moveEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canInclude) ? _c('v-list-tile', {
    on: {
      "click": _vm.includeStart
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "min-width": "290px",
      "color": "primary",
      "close-on-content-click": false,
      "nudge-right": 40
    },
    model: {
      value: (_vm.including),
      callback: function($$v) {
        _vm.including = $$v
      },
      expression: "including"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.include)
    }
  })]), _vm._v(" "), (_vm.includingDate) ? _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetDate),
      callback: function($$v) {
        _vm.targetDate = $$v
      },
      expression: "targetDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.includingDate = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.includeEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e(), _vm._v(" "), (_vm.includingTime) ? _c('v-time-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.targetTime),
      callback: function($$v) {
        _vm.targetTime = $$v
      },
      expression: "targetTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.includingTime = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerCancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.includeEnd
    }
  }, [_vm._v(_vm._s(_vm.labels.pickerOk))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("scheduleActionsAdditional", null, null, {
    schedule: _vm.schedule,
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar
  })], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n    " + _vm._s(_vm.customDescription) + "\n  ")]), _vm._v(" "), _c('ds-schedule-frequency-year', {
    attrs: {
      "day": _vm.day,
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-month', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-week', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-day-of-week', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-day', {
    attrs: {
      "schedule": _vm.schedule
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week"
  }, [_vm._l((_vm.days), function(day, i) {
    return [_c('ds-day', _vm._g(_vm._b({
      key: i,
      attrs: {
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-day', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// lib/dayspan-vuetify.min.js